// import React, { useEffect, useState, useRef } from "react";
// import {
//   FaSignOutAlt,
//   FaBars,
//   FaUserCircle,
//   FaEdit,
//   FaTrash,
//   FaPlus,
//   FaTimes,
//   FaEye,
//   FaCheck,
//   FaCertificate,
//   FaDownload,
//   FaSearch,
// } from "react-icons/fa";
// import {
//   MdApps,
//   MdAssignment,
//   MdBadge,
//   MdBuild,
//   MdBusinessCenter,
//   MdCategory,
//   MdContactMail,
//   MdDashboard,
//   MdEvent,
//   MdGrade,
//   MdGroup,
//   MdImage,
//   MdInsertChart,
//   MdLink,
//   MdPerson,
//   MdPhotoLibrary,
//   MdPostAdd,
//   MdSettings,
//   MdSlideshow,
//   MdStar,
//   MdStore,
//   MdTv,
//   MdVerified,
//   MdWork,
// } from "react-icons/md";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import {
//   FacebookEmbed,
//   InstagramEmbed,
//   YouTubeEmbed,
// } from "react-social-media-embed"

// const API = "https://infosightapi.emedha.in";


// const Info = ({ label, value }) => (
//   <div
//     style={{
//       background: "#fff",
//       border: "1px solid #eee",
//       borderRadius: 8,
//       padding: "10px 12px",
//       boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
//     }}
//   >
//     <strong style={{ color: "var(--primary)" }}>{label}:</strong>
//     <div style={{ marginTop: 4, color: "#555" }}>{value}</div>
//   </div>
// );

// const spinnerStyle = {
//   width: "14px",
//   height: "14px",
//   border: "2px solid #fff",
//   borderTop: "2px solid transparent",
//   borderRadius: "50%",
//   display: "inline-block",
//   animation: "spin 0.7s linear infinite",
// };

// // Keyframes injected inline
// const spinKeyframes = `
//   @keyframes spin {
//     from { transform: rotate(0deg); }
//     to { transform: rotate(360deg); }
//   }
// `;



// const AdminDashboard = () => {
//   const adminEmail = sessionStorage.getItem("adminEmail");
//   const navigate = useNavigate();

//   const [sidebarOpen, setSidebarOpen] = useState(true);
//   const [activeComponent, setActiveComponent] = useState(
//     localStorage.getItem("activeComponent") || "Dashboard"
//   );
//   const [showProfileMenu, setShowProfileMenu] = useState(false);
//   const profileMenuRef = useRef(null);

//   const [images, setImages] = useState([]); // State for storing uploaded images

 



// //--- Projects Page ---//
// const [projects, setProjects] = useState([]);
// const [formP, setFormP] = useState({
//   name: "",
//   category: "Hospitality",
//   country: "United Arab Emirates",
//   scope_of_work: "",   // <-- ADD
//   description: "",     // <-- ADD
//   image: null
// });

// const [editingP, setEditingP] = useState(null);
// const [showModalP, setShowModalP] = useState(false);

// // Pagination
// const [currentPageP, setCurrentPageP] = useState(1);
// const itemsPerPageP = 10;
// const totalPagesP = Math.ceil(projects.length / itemsPerPageP);
// const currentItemsP = projects.slice(
//   (currentPageP - 1) * itemsPerPageP,
//   currentPageP * itemsPerPageP
// );


// const fetchProjects = async () => {
//   const { data } = await axios.get(`${API}/api/projects`);
//   setProjects(data);
// };

// useEffect(() => {
//   fetchProjects();
// }, []);

// const handleImageP = (e) => {
//   setFormP({ ...formP, image: e.target.files[0] });
// };

// const handleSubmitP = async (e) => {
//   e.preventDefault();
//   const data = new FormData();

//   data.append("name", formP.name);
//   data.append("category", formP.category);
//   data.append("country", formP.country);
// // ADD THESE
// data.append("scope_of_work", formP.scope_of_work);
// data.append("description", formP.description);

//   if (formP.image instanceof File) {
//     data.append("image", formP.image);
//   }

//   if (editingP) {
//     await axios.put(`${API}/api/projects/${editingP}`, data);
//   } else {
//     await axios.post(`${API}/api/projects`, data);
//   }

//   setShowModalP(false);
//   setFormP({ name: "", category: "Hospitality", country: "United Arab Emirates", image: null });
//   setEditingP(null);
//   fetchProjects();
// };


// const handleEditP = (p) => {
//   setFormP({ name: p.name, category: p.category, country: p.country,   scope_of_work: p.scope_of_work,  description: p.description, image: p.image });
//   setEditingP(p.id);
//   setShowModalP(true);
// };

// const handleDeleteP = async (id) => {
//   if (window.confirm("Delete this project?")) {
//     await axios.delete(`${API}/api/projects/${id}`);
//     fetchProjects();
//   }
// };


// //-----Hero Sliders -------//



//  const [sliders, setSliders] = useState([]);
//   const [showModal, setShowModal] = useState(false);

//   const [form, setForm] = useState({
//     title: "",
//     location: "",
//     image: null,
//     order_no: "",
//   });

//   const [editingID, setEditingID] = useState(null);

//   // Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;
//   const totalPages = Math.ceil(sliders.length / itemsPerPage);
//   const currentItems = sliders.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//   // Fetch Sliders
//   const fetchSliders = async () => {
//     const { data } = await axios.get(`${API}/api/hero-sliders`);
//     setSliders(data);
//   };

//   useEffect(() => {
//     fetchSliders();
//   }, []);


//   const orderOptions = Array.from(
//   { length: sliders.length + (editingID ? 0 : 1) },
//   (_, i) => i + 1
// );


//   const handleImage = (e) => {
//     setForm({ ...form, image: e.target.files[0] });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const fd = new FormData();
//     fd.append("title", form.title);
//     fd.append("location", form.location);
//     if (form.image instanceof File) fd.append("image", form.image);
//     fd.append("order_no", form.order_no);


//     if (editingID) {
//       await axios.put(`${API}/api/hero-sliders/${editingID}`, fd);
//     } else {
//       await axios.post(`${API}/api/hero-sliders`, fd);
//     }

//     setShowModal(false);
//     setEditingID(null);
//     setForm({ title: "", location: "", image: null });
//     fetchSliders();
//   };

//   const handleEdit = (slide) => {
//     setEditingID(slide.id);
//     setForm({
//       title: slide.title,
//       location: slide.location,
//       image: slide.image,
//           order_no: slide.order_no,
//     });
//     setShowModal(true);
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm("Delete this slide?")) return;
//     await axios.delete(`${API}/api/hero-sliders/${id}`);
//     fetchSliders();
//   };

//   // ----- Job Applications -------//

// const [applications, setApplications] = useState([]);

// // Pagination
// const [currentPageA, setCurrentPageA] = useState(1);
// const itemsPerPageA = 10;
// const totalPagesA = Math.ceil(applications.length / itemsPerPageA);

// const currentItemsA = applications.slice(
//   (currentPageA - 1) * itemsPerPageA,
//   currentPageA * itemsPerPageA
// );

// // Fetch Applications
// const fetchApplications = async () => {
//   const { data } = await axios.get(`${API}/api/applications`);
//   setApplications(data);
// };

// useEffect(() => {
//   fetchApplications();
// }, []);





//   // ---- Services Menus ---- //

// const [menus, setMenus] = useState([]);
// const [menuName, setMenuName] = useState("");
// const [editingIDSm, setEditingIDSm] = useState(null);

// // Pagination
// const [currentPageSm, setCurrentPageSm] = useState(1);
// const itemsPerPageSm = 10;
// const totalPagesSm = Math.ceil(menus.length / itemsPerPageSm);
// const currentItemsSm = menus.slice(
//   (currentPageSm - 1) * itemsPerPageSm,
//   currentPageSm * itemsPerPageSm
// );

// // Fetch menus
// const fetchMenus = async () => {
//   const { data } = await axios.get(`${API}/api/services-menus`);
//   setMenus(data);
// };

// useEffect(() => {
//   fetchMenus();
// }, []);

// // Add / Edit menu
// const handleSubmitMenu = async (e) => {
//   e.preventDefault();

//   if (!menuName.trim()) return;

//   if (editingIDSm) {
//     // Update
//     await axios.put(`${API}/api/services-menus/${editingIDSm}`, {
//       menu_name: menuName,
//     });
//   } else {
//     // Add
//     await axios.post(`${API}/api/services-menus`, {
//       menu_name: menuName,
//     });
//   }

//   setMenuName("");
//   setEditingIDSm(null);
//   fetchMenus();
// };

// // Edit Row
// const handleEditMenu = (menu) => {
//   setMenuName(menu.menu_name);
//   setEditingIDSm(menu.id);
// };

// // Delete Row
// const handleDeleteMenu = async (id) => {
//   if (!window.confirm("Delete this menu?")) return;

//   await axios.delete(`${API}/api/services-menus/${id}`);
//   fetchMenus();
// };



// //-------- Serices -----------//



//   const [services, setServices] = useState([]);

//   // Form data
// const [formS, setFormS] = useState({
//   menu_id: "",
//   image: null,
//   heading: "",
//   paragraph: "",
//   bullet_points: ""
// });


//   const [editingS, setEditingS] = useState(null);
//   const [showModalS, setShowModalS] = useState(false);

//   // Pagination
//   const [currentPageS, setCurrentPageS] = useState(1);
//   const itemsPerPageS = 10;
//   const totalPagesS = Math.ceil(services.length / itemsPerPageS);

//   const currentItemsS = services.slice(
//     (currentPageS - 1) * itemsPerPageS,
//     currentPageS * itemsPerPageS
//   );


//   const addBullet = () => {
//   setFormS({ ...formS, bullet_points: [...formS.bullet_points, ""] });
// };


//   // Fetch Services
//   const fetchServices = async () => {
//     const { data } = await axios.get(`${API}/api/services`);
//     setServices(data);
//   };

//   useEffect(() => {
//     fetchMenus();
//     fetchServices();
//   }, []);

//   // Image Handler
//   const handleImageS = (e) => {
//     setFormS({ ...formS, image: e.target.files[0] });
//   };

//     // Add new heading & description block
//   const addContentBlock = () => {
//     setFormS({
//       ...formS,
//       content: [...formS.content, { heading: "", description: "" }],
//     });
//   };

//   // Remove block
//   const removeContentBlock = (index) => {
//     const updated = [...formS.content];
//     updated.splice(index, 1);
//     setFormS({ ...formS, content: updated });
//   };

//   // Update heading/description
//   const updateContentBlock = (index, field, value) => {
//     const updated = [...formS.content];
//     updated[index][field] = value;
//     setFormS({ ...formS, content: updated });
//   };


//     // Submit (Add or Update)
// const handleSubmitS = async (e) => {
//   e.preventDefault();

//   const data = new FormData();
//   data.append("menu_id", formS.menu_id);
//   data.append("paragraph", formS.paragraph);
//   data.append("heading", formS.heading);
//  data.append(
//   "bullet_points",
//   JSON.stringify(formS.bullet_points.split("\n").filter(x => x.trim() !== ""))
// );


//   if (formS.image instanceof File) {
//     data.append("image", formS.image);
//   }

//   if (editingS) {
//     await axios.put(`${API}/api/services/${editingS}`, data);
//   } else {
//     await axios.post(`${API}/api/services`, data);
//   }

//   setShowModalS(false);
//   setEditingS(null);

//   setFormS({
//     menu_id: "",
//     image: null,
//     paragraph: "",
//     heading: "",
//       bullet_points: ""
//   });

//   fetchServices();
// };


//   // Edit
//   const handleEditS = (service) => {
//  setFormS({
//   menu_id: service.menu_id,
//   image: service.image,
//   heading: service.heading,
//   paragraph: service.paragraph,
//   bullet_points: JSON.parse(service.bullet_points).join("\n"),
// });


//     setEditingS(service.id);
//     setShowModalS(true);
//   };

//   // Delete
//   const handleDeleteS = async (id) => {
//     if (window.confirm("Delete this service?")) {
//       await axios.delete(`${API}/api/services/${id}`);
//       fetchServices();
//     }
//   };




// //---------------  Clients --------------------//

// const [clients, setClients] = useState([]);

// const [formC, setFormC] = useState({
//   client_name: "",
//   image: null
// });

// const [editingC, setEditingC] = useState(null);
// const [showModalC, setShowModalC] = useState(false);


// const fetchClients = async () => {
//   const { data } = await axios.get(`${API}/api/clients`);
//   setClients(data);
// };

// useEffect(() => {
//   fetchClients();
// }, []);



// const handleImageC = e => {
//   setFormC({ ...formC, image: e.target.files[0] });
// };



// const handleSubmitC = async e => {
//   e.preventDefault();

//   const data = new FormData();

//   data.append("client_name", formC.client_name);

//   if (formC.image instanceof File) {
//     data.append("image", formC.image);
//   }

//   if (editingC) {
//     await axios.put(`${API}/api/clients/${editingC}`, data);
//   } else {
//     await axios.post(`${API}/api/clients`, data);
//   }

//   setShowModalC(false);
//   setEditingC(null);

//   setFormC({ client_name:"", image:null });

//   fetchClients();
// };


// const handleEditC = client => {
//   setFormC({
//     client_name: client.client_name,
//     image: client.image
//   });

//   setEditingC(client.id);
//   setShowModalC(true);
// };


// const handleDeleteC = async id => {
//   if (!window.confirm("Delete this client?")) return;

//   await axios.delete(`${API}/api/clients/${id}`);
//   fetchClients();
// };


// // -------- Careers ----------- //

// const [careers, setCareers] = useState([]);

// const [formCar, setFormCar] = useState({
//   post: "",
//   experience: "",
//   description: "",
//  sections: [] ,
//   vacancies: ""
// });

// const [editingCar, setEditingCar] = useState(null);
// const [showModalCar, setShowModalCar] = useState(false);

// // Pagination
// const [currentPageCar, setCurrentPageCar] = useState(1);
// const itemsPerPageCar = 10;
// const totalPagesCar = Math.ceil(careers.length / itemsPerPageCar);

// const currentItemsCar = careers.slice(
//   (currentPageCar- 1) * itemsPerPageCar,
//   currentPageCar * itemsPerPageCar
// );


// const addSection = () => {
//   setFormCar(prev => ({
//     ...prev,
//     sections: Array.isArray(prev.sections)
//       ? [...prev.sections, { heading: "", content: "" }]
//       : [{ heading: "", content: "" }]
//   }));
// };


// const updateSection = (index, field, value) => {
//   const updated = [...formCar.sections];
//   updated[index][field] = value;
//   setFormCar({ ...formCar, sections: updated });
// };

// const removeSection = (index) => {
//   const updated = formCar.sections.filter((_, i) => i !== index);
//   setFormCar({ ...formCar, sections: updated });
// };


// // Fetch Careers
// const fetchCareers = async () => {
//   const { data } = await axios.get(`${API}/api/careers`);
//   setCareers(data);
// };

// useEffect(() => {
//   fetchCareers();
// }, []);

// // Submit
// const handleSubmitCar = async (e) => {
//   e.preventDefault();

//   if (editingCar) {
//     await axios.put(`${API}/api/careers/${editingCar}`, formCar);
//   } else {
//     await axios.post(`${API}/api/careers`, formCar);
//   }

//   setShowModalCar(false);
//   setEditingCar(null);

//   setFormCar({
//     post: "",
//     experience: "",
//     description: "",
//     sections: [] ,
//     vacancies: ""
//   });

//   fetchCareers();
// };

// // Edit
// const handleEditCar = (c) => {
//   setFormCar({
//     post: c.post,
//     experience: c.experience,
//     description: c.description,
//      sections: Array.isArray(c.sections) ? c.sections : [],
//     vacancies: c.vacancies
//   });
//   setEditingCar(c.id);
//   setShowModalCar(true);
// };

// // Delete
// const handleDeleteCar = async (id) => {
//   if (window.confirm("Delete this career?")) {
//     await axios.delete(`${API}/api/careers/${id}`);
//     fetchCareers();
//   }
// };

// //---------------  Status Cards --------------------//

// const [statusCards, setStatusCards] = useState([]);

// const [formSC, setFormSC] = useState({
//   name: "",
//   count: ""
// });

// const [editingSC, setEditingSC] = useState(null);
// const [showModalSC, setShowModalSC] = useState(false);

// const fetchStatusCards = async () => {
//   const { data } = await axios.get(`${API}/api/status-cards`);
//   setStatusCards(data);
// };

// useEffect(() => {
//   fetchStatusCards();
// }, []);

// const handleSubmitSC = async e => {
//   e.preventDefault();

//   if (editingSC) {
//     await axios.put(`${API}/api/status-cards/${editingSC}`, formSC);
//   } else {
//     await axios.post(`${API}/api/status-cards`, formSC);
//   }

//   setFormSC({ name: "", count: "" });
//   setEditingSC(null);
//   setShowModalSC(false);
//   fetchStatusCards();
// };

// const handleEditSC = (card) => {
//   setFormSC({
//     name: card.name,
//     count: card.count
//   });
//   setEditingSC(card.id);
//   setShowModalSC(true);
// };

// const handleDeleteSC = async (id) => {
//   if (!window.confirm("Delete status card?")) return;
//   await axios.delete(`${API}/api/status-cards/${id}`);
//   fetchStatusCards();
// };



// //-----------Why Choose Cards -----------//



//   const [cards, setCards] = useState([]);
//   const [formWc, setFormWc] = useState({ name: "", status: "" });
//   const [editingWc, setEditingWc] = useState(null);

//   // Fetch cards
//   const fetchCards = async () => {
//     const { data } = await axios.get(`${API}/api/why-choose-cards`);
//     setCards(data);
//   };

//   useEffect(() => {
//     fetchCards();
//   }, []);

//   // Submit form
//   const handleSubmitWc = async (e) => {
//     e.preventDefault();
//     if (editingWc) {
//       await axios.put(`${API}/api/why-choose-cards/${editingWc}`, formWc);
//     } else {
//       await axios.post(`${API}/api/why-choose-cards`, formWc);
//     }
//     setFormWc({ name: "", status: "" });
//     setEditingWc(null);
//     fetchCards();
//   };

//   // Edit card
//   const handleEditWc = (card) => {
//     setFormWc({ name: card.name, status: card.status });
//     setEditingWc(card.id);
//   };

//   // Delete card
//   const handleDeleteWc = async (id) => {
//     if (!window.confirm("Delete this card?")) return;
//     await axios.delete(`${API}/api/why-choose-cards/${id}`);
//     fetchCards();
//   };


//   // ----- Contacts -------//

// const [contacts, setContacts] = useState([]);

// // Pagination
// const [currentPageF, setCurrentPageF] = useState(1);
// const itemsPerPageF = 10;
// const totalPagesF = Math.ceil(contacts.length / itemsPerPageF);

// const currentItemsF = contacts.slice(
//   (currentPageF - 1) * itemsPerPageF,
//   currentPageF * itemsPerPageF
// );

// // Fetch Contacts
// const fetchContacts = async () => {
//   const { data } = await axios.get(`${API}/api/contacts`);
//   setContacts(data);
// };

// useEffect(() => {
//   fetchContacts();
// }, []);




//   const allNavItems = [
//     { label: "Dashboard", icon: <MdDashboard /> },
   
//   { label: "Hero Sliders", icon: <MdSlideshow /> },
//     { label: "Projects", icon: <MdWork /> },


//       { label: "Services Menus", icon: <MdApps/> },
//        { label: "Services", icon: <MdBuild /> },
//        { label: "Clients", icon: <MdPerson /> },
//        { label: "Contact Forms", icon: <MdContactMail /> },

// { label: "Careers", icon: <MdBusinessCenter /> },
// { label: "Job Applications", icon: <MdAssignment /> },

// { label: "Status Cards", icon: <MdInsertChart /> },  
// { label: "Why Choose Cards", icon: <MdStar /> }

  
//   ];


// useEffect(() => {
//     localStorage.setItem("activeComponent", activeComponent);
//   }, [activeComponent]);

//   const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

// useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (
//         profileMenuRef.current &&
//         !profileMenuRef.current.contains(e.target)
//       ) {
//         setShowProfileMenu(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

// const handleLogout = () => {
//   sessionStorage.removeItem("isAdminLoggedIn");
//   sessionStorage.removeItem("adminEmail");
//   navigate("/admin-login");
// };




//   const renderContent = () => {



// if (activeComponent === "Projects") {
//   return (
//     <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
//       <div style={{ display: "flex", justifyContent: "space-between" }}>
//         <h2 style={{ color: "var(--primary)" }}>Projects</h2>

//         <button
//           onClick={() => {
//             setFormP({ name: "", category: "Hospitality", country: "United Arab Emirates", image: null });
//             setEditingP(null);
//             setShowModalP(true);
//           }}
//           style={{
//             background: "#132e55",
//             color: "#fff",
//             border: "none",
//             padding: "8px 13px",
//             borderRadius: 6,
//             display: "flex",
//             alignItems: "center",
//             height: "40px",
//             cursor: "pointer",
//           }}
//         >
//           <FaPlus style={{ marginRight: 6 }} /> Add
//         </button>
//       </div>

//       {/* Table */}
//       <table style={{ width: "100%", marginTop: 20, border: "1px solid #ddd" }}>
//         <thead style={{ background: "var(--primary)", color: "#fff" }}>
//           <tr>
// <th style={{ padding: "6px 6px", height: "20px" }}>#</th>
// <th style={{ padding: "6px 6px", height: "20px" }}>Name</th>
// <th style={{ padding: "6px 6px", height: "20px" }}>Category</th>
// <th style={{ padding: "6px 6px", height: "20px" }}>Country</th>
// <th style={{ padding: "6px 6px", height: "20px" }}>Scope of Work</th>
// <th style={{ padding: "6px 6px", height: "20px" }}>Description</th>
// <th style={{ padding: "6px 6px", height: "20px" }}>Image</th>
// <th style={{ padding: "6px 6px", height: "20px" }}>Actions</th>

//           </tr>
//         </thead>

//         <tbody>
//           {currentItemsP.map((p, i) => (
//             <tr key={p.id}>
//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{i + 1}</td>
//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{p.name}</td>
//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{p.category}</td>
//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{p.country}</td>
//               {/* ADD */}

// {/* ADD */}
// <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//   {p.scope_of_work}
// </td>

// <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//   {p.description}
// </td>


//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                 <img src={p.image} alt="project" style={{ width: 100, borderRadius: 6 }} />
//               </td>

//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                 <button
//                   onClick={() => handleEditP(p)}
//                   style={{ background: "var(--primary)", color: "#fff", marginRight: 6 }}
//                 >
//                   <FaEdit />
//                 </button>

//                 <button
//                   onClick={() => handleDeleteP(p.id)}
//                   style={{ background: "var(--accent)", color: "#132e55" }}
//                 >
//                   <FaTrash />
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {/* Pagination */}
// {totalPagesP > 1 && (
//   <div
//     style={{
//       marginTop: 20,
//       display: "flex",
//       justifyContent: "center",
//       gap: 6,
//       alignItems: "center",
//     }}
//   >
//     {/* Prev Button */}
//     <button
//       disabled={currentPageP === 1}
//       onClick={() => setCurrentPageP((p) => p - 1)}
//       style={{
//         padding: "6px 12px",
//         borderRadius: 6,
//         border: "1px solid #ccc",
//         background: currentPageP === 1 ? "#eee" : "var(--primary)",
//         color: currentPageP === 1 ? "#555" : "#fff",
//         cursor: currentPageP === 1 ? "not-allowed" : "pointer",
//       }}
//     >
//       Prev
//     </button>

//     {/* Page Numbers */}
//     {Array.from({ length: totalPagesP }, (_, i) => i + 1).map((page) => (
//       <button
//         key={page}
//         onClick={() => setCurrentPageP(page)}
//         style={{
//           padding: "6px 10px",
//           border: "1px solid #ccc",
//           borderRadius: 6,
//           cursor: "pointer",
//           background: currentPageP === page ? "var(--primary)" : "#fff",
//           color: currentPageP === page ? "#fff" : "#333",
//           fontWeight: currentPageP === page ? "bold" : "normal",
//         }}
//       >
//         {page}
//       </button>
//     ))}

//     {/* Next Button */}
//     <button
//       disabled={currentPageP === totalPagesP}
//       onClick={() => setCurrentPageP((p) => p + 1)}
//       style={{
//         padding: "6px 12px",
//         borderRadius: 6,
//         border: "1px solid #ccc",
//         background: currentPageP === totalPagesP ? "#eee" : "var(--primary)",
//         color: currentPageP === totalPagesP ? "#555" : "#fff",
//         cursor: currentPageP === totalPagesP ? "not-allowed" : "pointer",
//       }}
//     >
//       Next
//     </button>
//   </div>
// )}


//       {/* Modal */}
//       {showModalP && (
//         <div
//           style={{
//             position: "fixed",
//             inset: 0,
//             background: "rgba(0,0,0,0.4)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 1000,
//           }}
//         >
//           <div
//             style={{
//               background: "#fff",
//               borderRadius: 12,
//               width: "90%",
//               maxWidth: 420,
//               padding: 25,
//                maxHeight: "90vh",   // <-- limits modal height
//     overflowY: "auto",   // <-- enables vertical scroll
//     scrollbarWidth: "thin", // <-- optional (Firefox)
//             }}
//           >


//                   <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           marginBottom: 20,
//           borderBottom: "1px solid #eee",
//           paddingBottom: 10,
//         }}
//       >
//         <h3 style={{ color: "var(--primary)" }}>
//               {editingP ? "Edit Project" : "Add Project"}
//             </h3>
//         <FaTimes
//           onClick={() => setShowModalP(false)}
//           style={{
//             cursor: "pointer",
//             color: "#555",
//             fontSize: 18,
//             transition: "0.2s",
//           }}
//           onMouseOver={(e) => (e.currentTarget.style.color = "var(--accent)")}
//           onMouseOut={(e) => (e.currentTarget.style.color = "#555")}
//         />
//       </div>
           

//             <form onSubmit={handleSubmitP} style={{ marginTop: 15 }}>
              
//               <label>Project Name</label>
//               <input
//                 type="text"
//                 value={formP.name}
//                 onChange={(e) => setFormP({ ...formP, name: e.target.value })}
//                 style={{   width: "95%",
//     border: "1px solid #ccc",
//     borderRadius: 6,
//     padding: "8px",
//     fontSize: 14,
//     cursor: "pointer",marginBottom: 15}}
//                 required
//               />

//               <label>Category</label>
//               <select
//                 value={formP.category}
//                 onChange={(e) => setFormP({ ...formP, category: e.target.value })}
//                 style={{   width: "100%",
//     border: "1px solid #ccc",
//     borderRadius: 6,
//     padding: "8px",
//     fontSize: 14,
//     cursor: "pointer",
//   marginBottom: 15 }}
//               >
//                 <option>Hospitality</option>
//                 <option>Residential</option>
//                 <option>Mixed Use</option>
//                 <option>Corporate & Government</option>
//                 <option>Recreational</option>
//                 <option>Educational - House of Worship</option>
//               </select>

//               <label>Country</label>
//               <select
//                 value={formP.country}
//                 onChange={(e) => setFormP({ ...formP, country: e.target.value })}
//                 style={{   width: "100%",
//     border: "1px solid #ccc",
//     borderRadius: 6,
//     padding: "8px",
//     fontSize: 14,
//     cursor: "pointer", 
//     marginBottom: 15
//   }}
//               >
//                 <option>United Arab Emirates</option>
//                 <option>Kingdom of Saudi Arabia</option>
//                 <option>Oman</option>
//                 <option>India</option>
//                 <option>Iraq</option>
//                 <option>Tanzania</option>
//                 <option>Kuwait</option>
//                 <option>Ghana</option>
//                 <option>Egypt</option>
//                 <option>Bahrain</option>
//                 <option>Uganda</option>
//                 <option>Qatar</option>
//               </select>
// {/* Scope of Work */}
// <label>Scope of Work</label>
// <input
//   type="text"
//   value={formP.scope_of_work}
//   onChange={(e) => setFormP({ ...formP, scope_of_work: e.target.value })}
//   style={{
//     width: "95%",
//     border: "1px solid #ccc",
//     borderRadius: 6,
//     padding: "8px",
//     fontSize: 14,
//     cursor: "pointer",
//     marginBottom: 15
//   }}
// />

// {/* Description */}
// <label>Description</label>
// <textarea
//   value={formP.description}
//   onChange={(e) => setFormP({ ...formP, description: e.target.value })}
//   rows={4}
//   style={{
//     width: "95%",
//     border: "1px solid #ccc",
//     borderRadius: 6,
//     padding: "8px",
//     fontSize: 14,
//     cursor: "pointer",
//     marginBottom: 15,
//     resize: "vertical"
//   }}
// />

//               <label>Image</label>
//               <input type="file" onChange={handleImageP} style={{  width: "95%",
//     border: "1px solid #ccc",
//     borderRadius: 6,
//     padding: "8px",
//     fontSize: 14,
//     cursor: "pointer", marginBottom: 15 }} />

//               {formP.image && (
//                 <img
//                   src={
//                     typeof formP.image === "string"
//                       ? formP.image
//                       : URL.createObjectURL(formP.image)
//                   }
//                   style={{ width: "100px", borderRadius: 8, marginBottom: 10 }}
//                 />
//               )}

//               <button
//                 type="submit"
//                       style={{
//             background: "var(--primary)",
//             color: "#fff",
//             padding: "10px 15px",
//             borderRadius: 6,
//             marginTop: 15,
//             width: "100%",
//             fontWeight: 600,
//             fontSize: 15,
//             cursor: "pointer",
//             border: "none",
//             transition: "0.3s",
//           }}
//           onMouseOver={(e) =>
//             (e.currentTarget.style.background = "var(--primary)")
//           }
//           onMouseOut={(e) =>
//             (e.currentTarget.style.background = "var(--primary)")
//           }
//               >
//                 {editingP ? "Update" : "Add"}
//               </button>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }


// if(activeComponent==="Hero Sliders"){
//    return (
//     <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
//       {/* Header */}
//       <div style={{ display: "flex", justifyContent: "space-between" }}>
//         <h2 style={{ color: "var(--primary)" }}>Hero Sliders</h2>

//         <button
//           onClick={() => {
//             setForm({ title: "", location: "", image: null });
//             setEditingID(null);
//             setShowModal(true);
//           }}
//           style={{
//             background: "#132e55",
//             color: "#fff",
//             border: "none",
//             padding: "8px 13px",
//             borderRadius: 6,
//             display: "flex",
//             alignItems: "center",
//             height: "40px",
//             cursor: "pointer",
//           }}
//         >
//           <FaPlus style={{ marginRight: 6 }} /> Add
//         </button>
//       </div>

//       {/* Table */}
//       <table style={{ width: "100%", marginTop: 20, border: "1px solid #ddd" }}>
//         <thead style={{ background: "var(--primary)", color: "#fff" }}>
//           <tr>
//             <th style={{ padding: 6 }}>#</th>
//             <th style={{ padding: 6 }}>Title</th>
//             <th style={{ padding: 6 }}>Location</th>
//             <th style={{ padding: 6 }}>Image</th>
//             <th style={{padding:6}}>Order</th>
//             <th style={{ padding: 6 }}>Actions</th>
//           </tr>
//         </thead>

//         <tbody>
//           {currentItems.map((slider, i) => (
//             <tr key={slider.id}>
//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                 {i + 1}
//               </td>
//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                 {slider.title}
//               </td>
//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                 {slider.location}
//               </td>

//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                 <img
//                   src={slider.image}
//                   style={{ width: 120, borderRadius: 6 }}
//                   alt=""
//                 />
//               </td>
//  <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                 {slider.order_no}
//               </td>
//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                 <button
//                   onClick={() => handleEdit(slider)}
//                   style={{ background: "var(--primary)", color: "#fff", marginRight: 6 }}
//                 >
//                   <FaEdit />
//                 </button>

//                 <button
//                   onClick={() => handleDelete(slider.id)}
//                   style={{ background: "var(--accent)", color: "#132e55" }}
//                 >
//                   <FaTrash />
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {/* Pagination */}
//       {totalPages > 1 && (
//         <div
//           style={{
//             marginTop: 20,
//             display: "flex",
//             justifyContent: "center",
//             gap: 6,
//           }}
//         >
//           <button
//             disabled={currentPage === 1}
//             onClick={() => setCurrentPage((p) => p - 1)}
//             style={{
//               padding: "6px 12px",
//               borderRadius: 6,
//               background: currentPage === 1 ? "#eee" : "var(--primary)",
//               color: currentPage === 1 ? "#555" : "#fff",
//             }}
//           >
//             Prev
//           </button>

//           {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
//             <button
//               key={page}
//               onClick={() => setCurrentPage(page)}
//               style={{
//                 padding: "6px 10px",
//                 borderRadius: 6,
//                 background: currentPage === page ? "var(--primary)" : "#fff",
//                 color: currentPage === page ? "#fff" : "#333",
//               }}
//             >
//               {page}
//             </button>
//           ))}

//           <button
//             disabled={currentPage === totalPages}
//             onClick={() => setCurrentPage((p) => p + 1)}
//             style={{
//               padding: "6px 12px",
//               borderRadius: 6,
//               background: currentPage === totalPages ? "#eee" : "var(--primary)",
//               color: currentPage === totalPages ? "#555" : "#fff",
//             }}
//           >
//             Next
//           </button>
//         </div>
//       )}

//       {/* Modal */}
//       {showModal && (
//         <div
//           style={{
//             position: "fixed",
//             inset: 0,
//             background: "rgba(0,0,0,0.4)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 1000,
//           }}
//         >
//           <div
//             style={{
//               background: "#fff",
//               borderRadius: 12,
//               width: "90%",
//               maxWidth: 420,
//               padding: 25,
//             }}
//           >
//             {/* Title Row */}
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
            
//                 paddingBottom: 10,
//               }}
//             >
//               <h3 style={{ color: "var(--primary)" }}>
//                 {editingID ? "Edit Slide" : "Add Slide"}
//               </h3>
//               <FaTimes
//                 onClick={() => setShowModal(false)}
//                 style={{ cursor: "pointer" }}
//               />
//             </div>

//             <form onSubmit={handleSubmit}>

//               {/* Title */}
//               <label>Title</label>
//               <input
//                 type="text"
//                 value={form.title}
//                 onChange={(e) => setForm({ ...form, title: e.target.value })}
//                 style={{
//                   width: "95%",
//     border: "1px solid #ccc",
//     borderRadius: 6,
//     padding: "8px",
//     fontSize: 14,
//     cursor: "pointer",marginBottom: 15
//                 }}
//                 required
//               />

//               {/* Location */}
//               <label>Location</label>
//               <input
//                 type="text"
//                 value={form.location}
//                 onChange={(e) => setForm({ ...form, location: e.target.value })}
//                 style={{
//                   width: "95%",
//     border: "1px solid #ccc",
//     borderRadius: 6,
//     padding: "8px",
//     fontSize: 14,
//     cursor: "pointer",marginBottom: 15
//                 }}
//                 required
//               />

//               {/* Image */}
//               <label>Image</label>
//               <input
//                 type="file"
//                 onChange={handleImage}
//                 style={{  width: "95%",
//     border: "1px solid #ccc",
//     borderRadius: 6,
//     padding: "8px",
//     fontSize: 14,
//     cursor: "pointer",marginBottom: 15 }}
//               />



//               <label>Order</label>
// <select
//   value={form.order_no}
//   onChange={(e) =>
//     setForm({ ...form, order_no: e.target.value })
//   }
//   required
//   style={{  width: "95%",
//     border: "1px solid #ccc",
//     borderRadius: 6,
//     padding: "8px",
//     fontSize: 14,
//     cursor: "pointer",marginBottom: 15 }}
              
// >
//   <option value="">Select order</option>
//   {orderOptions.map((n) => (
//     <option key={n} value={n}>
//       {n}
//     </option>
//   ))}
// </select>


//               {form.image && (
//                 <img
//                   src={
//                     typeof form.image === "string"
//                       ? form.image
//                       : URL.createObjectURL(form.image)
//                   }
//                   style={{ width: 100, borderRadius: 8, marginBottom: 10 }}
//                 />
//               )}
//               <button
//                 type="submit"
//                      style={{
//             background: "var(--primary)",
//             color: "#fff",
//             padding: "10px 15px",
//             borderRadius: 6,
//             marginTop: 15,
//             width: "100%",
//             fontWeight: 600,
//             fontSize: 15,
//             cursor: "pointer",
//             border: "none",
//             transition: "0.3s",
//           }}
//           onMouseOver={(e) =>
//             (e.currentTarget.style.background = "var(--primary)")
//           }
//           onMouseOut={(e) =>
//             (e.currentTarget.style.background = "var(--primary)")
//           }
//               >
//                 {editingID ? "Update" : "Add"}
//               </button>

//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }


// if (activeComponent === "Job Applications") {
//   return (
//     <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
//       {/* Header */}
//       <div style={{ display: "flex", justifyContent: "space-between" }}>
//         <h2 style={{ color: "var(--primary)" }}>Applications</h2>
//       </div>

//       {/* Table */}
//       <table style={{ width: "100%", marginTop: 20, border: "1px solid #ddd" }}>
//         <thead style={{ background: "var(--primary)", color: "#fff" }}>
//           <tr>
//             <th style={{ padding: 6 }}>#</th>
//             <th style={{ padding: 6 }}>Job Title</th>
//             <th style={{ padding: 6 }}>Name</th>
//             <th style={{ padding: 6 }}>Email</th>
//             <th style={{ padding: 6 }}>Mobile</th>
//             <th style={{ padding: 6 }}>Resume</th>
//             <th style={{ padding: 6 }}>Applied On</th>
//           </tr>
//         </thead>

//         <tbody>
//           {currentItemsA.map((app, i) => (
//             <tr key={app.id}>
//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                 {(currentPage - 1) * itemsPerPage + i + 1}
//               </td>

//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                 {app.job_title}
//               </td>

//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                 {app.name}
//               </td>

//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                 {app.email}
//               </td>

//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                 {app.mobile}
//               </td>

//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                 <a
//                   href={app.resume_file}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   style={{
//                     color: "var(--primary)",
//                     fontWeight: 600,
//                     textDecoration: "underline",
//                   }}
//                 >
//                   View Resume
//                 </a>
//               </td>

//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>

//                 {new Date(app.created_at).toLocaleString("en-GB", {
//   day: "2-digit",
//   month: "2-digit",
//   year: "numeric",
//   hour: "2-digit",
//   minute: "2-digit",
//   hour12: false
// })}

//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {/* Pagination */}
//       {totalPagesA > 1 && (
//         <div
//           style={{
//             marginTop: 20,
//             display: "flex",
//             justifyContent: "center",
//             gap: 6,
//           }}
//         >
//           <button
//             disabled={currentPageA === 1}
//             onClick={() => setCurrentPageA((p) => p - 1)}
//             style={{
//               padding: "6px 12px",
//               borderRadius: 6,
//               background: currentPageA === 1 ? "#eee" : "var(--primary)",
//               color: currentPageA === 1 ? "#555" : "#fff",
//             }}
//           >
//             Prev
//           </button>

//           {Array.from({ length: totalPagesA }, (_, i) => i + 1).map((page) => (
//             <button
//               key={page}
//               onClick={() => setCurrentPageA(page)}
//               style={{
//                 padding: "6px 10px",
//                 borderRadius: 6,
//                 background: currentPageA === page ? "var(--primary)" : "#fff",
//                 color: currentPageA === page ? "#fff" : "#333",
//               }}
//             >
//               {page}
//             </button>
//           ))}

//           <button
//             disabled={currentPageA === totalPagesA}
//             onClick={() => setCurrentPageA((p) => p + 1)}
//             style={{
//               padding: "6px 12px",
//               borderRadius: 6,
//               background: currentPageA === totalPagesA ? "#eee" : "var(--primary)",
//               color: currentPageA === totalPagesA ? "#555" : "#fff",
//             }}
//           >
//             Next
//           </button>
//         </div>
//       )}
//     </div>
//   );
// }

// if (activeComponent === "Services Menus") {
//   return (
//     <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
//       <h2 style={{ color: "var(--primary)" }}>Services Menus</h2>

//       {/* Add New Menu */}
//       <form onSubmit={handleSubmitMenu} style={{ marginTop: 15, display:'flex', flexDirection:'row', alignItems:'center' }}>
//         {/* <label>Menu Name</label> */}
//         <input
//           type="text"
//           value={menuName}
//           onChange={(e) => setMenuName(e.target.value)}
//           placeholder="Enter menu name"
//           style={{
//             width: "350px",
//             border: "1px solid #ccc",
//             borderRadius: 6,
//             padding: "8px",
//             fontSize: 14,
        
//           }}
//           required
//         />

//         <button
//           type="submit"
//           style={{
//             background: "var(--primary)",
//             color: "#fff",
//             padding: "8px 15px",
//             borderRadius: 6,
//             border: "none",
//             cursor: "pointer",
//             marginLeft: 10,
//           }}
//         >
//           {editingIDSm ? "Update Menu" : "Add Menu"}
//         </button>
//       </form>

//       {/* Table */}
//       <table style={{ width: "100%", marginTop: 20, border: "1px solid #ddd" }}>
//         <thead style={{ background: "var(--primary)", color: "#fff" }}>
//           <tr>
//             <th style={{ padding: 6 }}>#</th>
//             <th style={{ padding: 6 }}>Menu Name</th>
//             <th style={{ padding: 6 }}>Actions</th>
//           </tr>
//         </thead>

//         <tbody>
//           {currentItemsSm.map((menu, i) => (
//             <tr key={menu.id}>
//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                 {(currentPage - 1) * itemsPerPage + (i + 1)}
//               </td>

//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                 {menu.menu_name}
//               </td>

//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                 <button
//                   onClick={() => handleEditMenu(menu)}
//                   style={{ background: "var(--primary)", color: "#fff", marginRight: 6 , cursor:'pointer'}}
//                 >
//                   <FaEdit />
//                 </button>

//                 <button
//                   onClick={() => handleDeleteMenu(menu.id)}
//                   style={{ background: "var(--accent)", color: "#132e55" ,  cursor:'pointer'}}
//                 >
//                   <FaTrash />
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {/* Pagination */}
//       {totalPages > 1 && (
//         <div style={{ marginTop: 20, display: "flex", justifyContent: "center", gap: 6 }}>
//           <button
//             disabled={currentPageSm === 1}
//             onClick={() => setCurrentPageSm((p) => p - 1)}
//             style={{
//               padding: "6px 12px",
//               borderRadius: 6,
//               background: currentPageSm === 1 ? "#eee" : "var(--primary)",
//               color: currentPageSm === 1 ? "#555" : "#fff",
//             }}
//           >
//             Prev
//           </button>

//           {Array.from({ length: totalPagesSm}, (_, i) => i + 1).map((page) => (
//             <button
//               key={page}
//               onClick={() => setCurrentPageSm(page)}
//               style={{
//                 padding: "6px 10px",
//                 borderRadius: 6,
//                 background: currentPageSm === page ? "var(--primary)" : "#fff",
//                 color: currentPageSm === page ? "#fff" : "#333",
//               }}
//             >
//               {page}
//             </button>
//           ))}

//           <button
//             disabled={currentPageSm === totalPagesSm}
//             onClick={() => setCurrentPageSm((p) => p + 1)}
//             style={{
//               padding: "6px 12px",
//               borderRadius: 6,
//               background: currentPage === totalPages ? "#eee" : "var(--primary)",
//               color: currentPage === totalPages ? "#555" : "#fff",
//             }}
//           >
//             Next
//           </button>
//         </div>
//       )}
//     </div>
//   );
// }

//   if (activeComponent === "Services") {
//     return (
//       <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
//         <div style={{ display: "flex", justifyContent: "space-between" }}>
//           <h2 style={{ color: "var(--primary)" }}>Services</h2>

//           <button
//             onClick={() => {
//               setFormS({
//                 menu_id: "",
//                 image: null,
//                 content: [{ heading: "", description: "" }],
//               });
//               setEditingS(null);
//               setShowModalS(true);
//             }}
//             style={{
//               background: "#132e55",
//               color: "#fff",
//               border: "none",
//               padding: "8px 13px",
//               borderRadius: 6,
//               display: "flex",
//               alignItems: "center",
//               height: "40px",
//               cursor: "pointer",
//             }}
//           >
//             <FaPlus style={{ marginRight: 6 }} /> Add
//           </button>
//         </div>

//         {/* Table */}
//         <table style={{ width: "100%", marginTop: 20, border: "1px solid #ddd" }}>
//           <thead style={{ background: "var(--primary)", color: "#fff" }}>
//             <tr>
//               <th  style={{ padding: 6 }}>#</th>
//               <th  style={{ padding: 6 }}>Menu</th>
//               <th  style={{ padding: 6 }}>Image</th>
//               <th  style={{ padding: 6 }}>Content Count</th>
//               <th  style={{ padding: 6 }}>Actions</th>
//             </tr>
//           </thead>

//           <tbody>
//             {currentItemsS.map((s, i) => (
//               <tr key={s.id}>
//                 <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{i + 1}</td>
//                 <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{s.menu_name}</td>
//                 <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                   <img src={s.image} style={{ width: 80, borderRadius: 6 }} />
//                 </td>
//            <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{JSON.parse(s.bullet_points).length} bullets</td>

//                 <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                   <button onClick={() => handleEditS(s)} style={{ background: "var(--primary)", color: "#fff" }}>
//                     <FaEdit />
//                   </button>
//                   <button
//                     onClick={() => handleDeleteS(s.id)}
//                     style={{ background: "var(--accent)", color: "#132e55" }}
//                   >
//                     <FaTrash />
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//         {/* Pagination */}
//         {totalPagesS > 1 && (
//           <div style={{ marginTop: 20, display: "flex", justifyContent: "center", gap: 6 }}>
//             <button disabled={currentPageS === 1} onClick={() => setCurrentPageS(currentPageS - 1)}>
//               Prev
//             </button>

//             {Array.from({ length: totalPagesS }, (_, i) => i + 1).map((page) => (
//               <button
//                 key={page}
//                 onClick={() => setCurrentPageS(page)}
//                 style={{
//                   background: currentPageS === page ? "var(--primary)" : "#fff",
//                   color: currentPageS === page ? "#fff" : "#333",
//                 }}
//               >
//                 {page}
//               </button>
//             ))}

//             <button disabled={currentPageS === totalPagesS} onClick={() => setCurrentPageS(currentPageS + 1)}>
//               Next
//             </button>
//           </div>
//         )}
//         {/* Modal */}
//         {showModalS && (
//           <div
//     style={{
//       position: "fixed",
//       inset: 0,
//       background: "rgba(0,0,0,0.4)",
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//       zIndex: 1000,
//       padding: "20px",          // EXTRA PADDING
//       overflowY: "auto"         // 🔥 Scroll the backdrop if modal is tall
//     }}
//   >
//           <div
//             style={{
//                      background: "#fff",
//         borderRadius: 12,
//         width: "100%",
//         maxWidth: 500,
//         maxHeight: "90vh",       // 🔥 Prevent height overflow
//         overflowY: "auto",       // 🔥 Add scroll ONLY inside modal
//         padding: 25,

//             }}
//           >
//             <div style={{ background: "#fff", borderRadius: 12, width: "90%", maxWidth: 450, padding: 25 }}>
//               <div style={{ display: "flex", justifyContent: "space-between" }}>
//                 <h3>{editingS ? "Edit Service" : "Add Service"}</h3>
//                 <FaTimes style={{ cursor: "pointer" }} onClick={() => setShowModalS(false)} />
//               </div>

//               <form onSubmit={handleSubmitS}>
//                 {/* Menu */}
//                 <label>Menu</label>
//                 <select
//                   value={formS.menu_id}
//                   onChange={(e) => setFormS({ ...formS, menu_id: e.target.value })}
//                   required
//                   style={{ width: "95%",
//     border: "1px solid #ccc",
//     borderRadius: 6,
//     padding: "8px",
//     fontSize: 14,
//     cursor: "pointer",marginBottom: 15}}
//                 >
//                   <option value="">Select Menu</option>
//                   {menus.map((m) => (
//                     <option key={m.id} value={m.id}>
//                       {m.menu_name}
//                     </option>
//                   ))}
//                 </select>

//                 {/* Image */}
//                 <label>Image</label>
//                 <input type="file" onChange={handleImageS}                style={{ width: "95%",
//     border: "1px solid #ccc",
//     borderRadius: 6,
//     padding: "8px",
//     fontSize: 14,
//     cursor: "pointer",marginBottom: 15}}/>
//                 {formS.image && (
//                   <img
//                     src={typeof formS.image === "string" ? formS.image : URL.createObjectURL(formS.image)}
//                     style={{ width: 100, marginTop: 1 }}
//                   />
//                 )}

//                 {/* Dynamic Content Blocks */}
//        <label>Paragraph</label>
// <textarea
//   value={formS.paragraph}
//   onChange={(e) => setFormS({ ...formS, paragraph: e.target.value })}
//   style={{ width: "95%",
//     border: "1px solid #ccc",
//     borderRadius: 6,
//     padding: "8px",
//     fontSize: 14,
//     marginTop: 15,
//     cursor: "pointer",marginBottom: 15}}
// />

// <label>Heading</label>
// <input
//   value={formS.heading}
//   onChange={(e) => setFormS({ ...formS, heading: e.target.value })}
//   style={{ width: "95%",
//     border: "1px solid #ccc",
//     borderRadius: 6,
//     padding: "8px",
//     fontSize: 14,
//     cursor: "pointer",marginBottom: 15}}
// />

// <label>Bullet Points (one per line)</label>
// <textarea
//   value={formS.bullet_points}
//   onChange={(e) => 
//     setFormS({ 
//       ...formS, 
//       bullet_points: e.target.value 
//     })
//   }
//   placeholder="Type each bullet in a new line"
//   style={{ width: "95%",
//     border: "1px solid #ccc",
//     borderRadius: 6,
//     padding: "8px",
//     fontSize: 14,
//     cursor: "pointer",marginBottom: 15}}
// />



//                 <button type="submit"    style={{
//             background: "var(--primary)",
//             color: "#fff",
//             padding: "10px 15px",
//             borderRadius: 6,
//             marginTop: 15,
//             width: "100%",
//             fontWeight: 600,
//             fontSize: 15,
//             cursor: "pointer",
//             border: "none",
//             transition: "0.3s",
//           }}
//           onMouseOver={(e) =>
//             (e.currentTarget.style.background = "var(--primary)")
//           }
//           onMouseOut={(e) =>
//             (e.currentTarget.style.background = "var(--primary)")
//           }>
//                   {editingS ? "Update" : "Add"}
//                 </button>
//               </form>
//             </div>
//           </div>
//               </div>
//         )}

//       </div>
//     );

//   }

// if (activeComponent === "Clients") {
//   return (
//     <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
//       <h2 style={{ color: "var(--primary)" }}>Clients</h2>

//       {/* Add / Edit Client Form */}
//       <form 
//         onSubmit={handleSubmitC}
//         style={{ marginTop: 15 }}
//       >
        
//         {/* <input
//           type="text"
//           placeholder="Client Name"
//           value={formC.client_name}
//           onChange={(e)=>setFormC({...formC, client_name:e.target.value})}
//           style={inputStyle}
//         /> */}

//         <label>Client Image</label>
//         <input 
//           type="file"
//           onChange={handleImageC}
//           style={inputStyle}
//         />

//         {formC.image && (
//           <img
//             src={typeof formC.image === "string"
//               ? formC.image
//               : URL.createObjectURL(formC.image)}
//             style={{ width:100, marginTop:10 }}
//           />
//         )}

//         <button 
//           type="submit"
//           style={btnStyle}
//         >
//           {editingC ? "Update Client" : "Add Client"}
//         </button>
//       </form>


//       {/* Table */}
//       <table style={tableStyle}>
//         <thead style={theadStyle}>
//           <tr>
//             <th style={{ padding: 6 }}>#</th>
//             {/* <th style={{ padding: 6 }}>Name</th> */}
//             <th style={{ padding: 6 }}>Image</th>
//             <th style={{ padding: 6 }}>Actions</th>
//           </tr>
//         </thead>

//         <tbody>
//           {clients.map((c,i)=>(
//             <tr key={c.id}>
//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{i+1}</td>
//               {/* <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{c.client_name}</td> */}
//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                 <img src={c.image} style={{width:80,borderRadius:6}} />
//               </td>
//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                 <button
//                   onClick={()=>handleEditC(c)}
//                   style={editBtn}
//                 >
//                   <FaEdit />
//                 </button>

//                 <button
//                   onClick={()=>handleDeleteC(c.id)}
//                   style={deleteBtn}
//                 >
//                   <FaTrash />
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
// {/* {showModalC && (
// <div className="modal">

// <form onSubmit={handleSubmitC}>

// <input
//   type="text"
//   placeholder="Client Name"
//   value={formC.client_name}
//   onChange={e => setFormC({...formC, client_name:e.target.value})}
// />

// <input type="file" onChange={handleImageC} />

// {formC.image && (
//   <img
//     src={typeof formC.image === "string"
//       ? formC.image
//       : URL.createObjectURL(formC.image)}
//     style={{width:100}}
//   />
// )}

// <button type="submit">
//   {editingC ? "Update" : "Add"}
// </button>

// </form>
// </div>
// )} */}

//     </div>
//   );
// }

// if (activeComponent === "Status Cards") {
//   return (
//     <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
//       <h2 style={{ color: "var(--primary)" }}>Status Cards</h2>

//       {/* Add / Edit Form */}
//       <form onSubmit={handleSubmitSC} style={{ marginTop: 15 }}>

//         <input
//           type="text"
//           placeholder="Status Name"
//           value={formSC.name}
//           onChange={(e) => setFormSC({...formSC, name: e.target.value})}
//            style={{
//                   width: "300px", border: "1px solid #ccc", borderRadius: 6,
//                   padding: "8px", margin: 15, marginLeft:0
//                 }}
//         />

//         <input
//           type="number"
//           placeholder="Count"
//           value={formSC.count}
//           onChange={(e)=> setFormSC({...formSC, count: e.target.value})}
//        style={{
//                   width: "300px", border: "1px solid #ccc", borderRadius: 6,
//                   padding: "8px", margin: 15
//                 }}
//         />

//         <button type="submit" style={btnStyle}>
//           {editingSC ? "Update" : "Add New"}
//         </button>
//       </form>


//       {/* Table */}
//       <table style={tableStyle}>
//         <thead style={theadStyle}>
//           <tr>
//             <th>#</th>
//             <th>Name</th>
//             <th>Count</th>
//             <th>Actions</th>
//           </tr>
//         </thead>

//         <tbody>
//           {statusCards.map((s, i) => (
//             <tr key={s.id}>
//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{i + 1}</td>
//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{s.name}</td>
//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{s.count}</td>

//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                 <button onClick={() => handleEditSC(s)} style={editBtn}>
//                   <FaEdit />
//                 </button>

//                 <button onClick={() => handleDeleteSC(s.id)} style={deleteBtn}>
//                   <FaTrash />
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>


//       {/* MODAL */}
//       {/* {showModalSC && (
//         <div className="modal">

//           <form onSubmit={handleSubmitSC}>

//             <input
//               type="text"
//               placeholder="Status Name"
//               value={formSC.name}
//               onChange={(e)=> setFormSC({...formSC, name: e.target.value})}
//             />

//             <input
//               type="number"
//               placeholder="Count"
//               value={formSC.count}
//               onChange={(e)=> setFormSC({...formSC, count: e.target.value})}
//             />

//             <button type="submit">
//               {editingSC ? "Update" : "Add"}
//             </button>

//           </form>

//         </div>
//       )} */}

//     </div>
//   );
// }


// if (activeComponent === "Contact Forms") {
//   return (
//     <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
//       {/* Header */}
//       <div style={{ display: "flex", justifyContent: "space-between" }}>
//         <h2 style={{ color: "var(--primary)" }}>Contacts</h2>
//       </div>

//       {/* Table */}
//       <table style={{ width: "100%", marginTop: 20, border: "1px solid #ddd" }}>
//         <thead style={{ background: "var(--primary)", color: "#fff" }}>
//           <tr>
//             <th style={{ padding: 6 }}>#</th>
//             <th style={{ padding: 6 }}>Name</th>
//             <th style={{ padding: 6 }}>Email</th>
//             <th style={{ padding: 6 }}>Organization</th>
//             <th style={{ padding: 6 }}>Subject</th>
//             <th style={{ padding: 6 }}>Message</th>
//             <th style={{ padding: 6 }}>Date</th>
//           </tr>
//         </thead>

//         <tbody>
//           {currentItemsF.map((contact, i) => (
//             <tr key={contact.id}>
//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                 {(currentPage - 1) * itemsPerPage + i + 1}
//               </td>

//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                 {contact.name}
//               </td>

//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                 {contact.email}
//               </td>

//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                 {contact.organization}
//               </td>

//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                 {contact.subject}
//               </td>

//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                 {contact.message}
//               </td>

//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//              {new Date(contact.createdAt).toLocaleString("en-GB", {
//   day: "2-digit",
//   month: "2-digit",
//   year: "numeric",
//   hour: "2-digit",
//   minute: "2-digit",
//   hour12: false
// })}

//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {/* Pagination */}
//       {totalPagesF > 1 && (
//         <div
//           style={{
//             marginTop: 20,
//             display: "flex",
//             justifyContent: "center",
//             gap: 6,
//           }}
//         >
//           <button
//             disabled={currentPageF === 1}
//             onClick={() => setCurrentPageF((p) => p - 1)}
//             style={{
//               padding: "6px 12px",
//               borderRadius: 6,
//               background: currentPageF === 1 ? "#eee" : "var(--primary)",
//               color: currentPageF === 1 ? "#555" : "#fff",
//             }}
//           >
//             Prev
//           </button>

//           {Array.from({ length: totalPagesF }, (_, i) => i + 1).map((page) => (
//             <button
//               key={page}
//               onClick={() => setCurrentPageF(page)}
//               style={{
//                 padding: "6px 10px",
//                 borderRadius: 6,
//                 background: currentPageF === page ? "var(--primary)" : "#fff",
//                 color: currentPageF === page ? "#fff" : "#333",
//               }}
//             >
//               {page}
//             </button>
//           ))}

//           <button
//             disabled={currentPageF === totalPagesF}
//             onClick={() => setCurrentPage((p) => p + 1)}
//             style={{
//               padding: "6px 12px",
//               borderRadius: 6,
//               background: currentPageF === totalPagesF ? "#eee" : "var(--primary)",
//               color: currentPageF === totalPagesF ? "#555" : "#fff",
//             }}
//           >
//             Next
//           </button>
//         </div>
//       )}
//     </div>
//   );
// }


// if (activeComponent === "Careers") {
//   return (
//     <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
//       <div style={{ display: "flex", justifyContent: "space-between" }}>
//         <h2 style={{ color: "var(--primary)" }}>Careers</h2>

//       <button
//   onClick={() => {
//     setFormCar({
//       post: "",
//       experience: "",
//       description: "",
//       vacancies: "",
//       sections: []   // ✅ THIS IS REQUIRED TO PREVENT CRASH
//     });
//     setEditingCar(null);
//     setShowModalCar(true);
//   }}
//   style={{
//     background: "#132e55",
//     color: "#fff",
//     border: "none",
//     padding: "8px 13px",
//     borderRadius: 6,
//     display: "flex",
//     alignItems: "center",
//     height: "40px",
//     cursor: "pointer",
//   }}
// >
//   <FaPlus style={{ marginRight: 6 }} /> Add
// </button>

//       </div>

//       {/* Table */}
//       <table style={{ width: "100%", marginTop: 20, border: "1px solid #ddd" }}>
//         <thead style={{ background: "var(--primary)", color: "#fff" }}>
//           <tr>
//             <th style={{ padding: 6 }}>#</th>
//             <th style={{ padding: 6 }}>Post</th>
//             <th style={{ padding: 6 }}>Experience</th>
//             <th style={{ padding: 6 }}>Vacancies</th>
//                 <th style={{ padding: 6 }}>Sections</th>
//             <th style={{ padding: 6 }}>Actions</th>
//           </tr>
//         </thead>

//         <tbody>
//           {currentItemsCar.map((c, i) => (
//             <tr key={c.id}>
//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{i + 1}</td>
//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{c.post}</td>
//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{c.experience} Years</td>

//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{c.vacancies}</td>
// <td style={{ border: "1px solid #ddd", fontSize: 12 }}>
//   {Array.isArray(c.sections) && c.sections.length > 0
//     ? c.sections.map(s => s.heading).join(", ").slice(0, 50) + "..."
//     : "-"}
// </td>

//               <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//                 <button onClick={() => handleEditCar(c)} style={{ background: "var(--primary)", color: "#fff" }}>
//                   <FaEdit />
//                 </button>
//                 <button
//                   onClick={() => handleDeleteCar(c.id)}
//                   style={{ background: "var(--accent)", color: "#132e55" }}
//                 >
//                   <FaTrash />
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {/* Pagination */}
//       {totalPagesCar > 1 && (
//         <div style={{ marginTop: 20, display: "flex", justifyContent: "center", gap: 6 }}>
//           <button disabled={currentPageCar === 1} onClick={() => setCurrentPageCar(currentPageCar - 1)}>
//             Prev
//           </button>

//           {Array.from({ length: totalPagesCar }, (_, i) => i + 1).map((page) => (
//             <button
//               key={page}
//               onClick={() => setCurrentPageCar(page)}
//               style={{
//                 background: currentPageCar === page ? "var(--primary)" : "#fff",
//                 color: currentPageCar === page ? "#fff" : "#333",
//               }}
//             >
//               {page}
//             </button>
//           ))}

//           <button disabled={currentPageCar === totalPagesCar} onClick={() => setCurrentPageCar(currentPageCar + 1)}>
//             Next
//           </button>
//         </div>
//       )}

//       {/* Modal */}
//       {showModalCar && (
//         <div
//           style={{
//             position: "fixed",
//             inset: 0,
//             background: "rgba(0,0,0,0.4)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 1000,
//             padding: "20px",
//             overflowY: "auto"
//           }}
//         >
//           <div
//             style={{
//               background: "#fff",
//               borderRadius: 12,
//               width: "100%",
//               maxWidth: 500,
//               maxHeight: "90vh",
//               overflowY: "auto",
//               padding: 25,
//             }}
//           >
//             <div style={{ display: "flex", justifyContent: "space-between" }}>
//               <h3>{editingC ? "Edit Career" : "Add Career"}</h3>
//               <FaTimes style={{ cursor: "pointer" }} onClick={() => setShowModalCar(false)} />
//             </div>

//             <form onSubmit={handleSubmitCar}>

//               <label>Post</label>
//               <input
//                 type="text"
//                 value={formCar.post}
//                 required
//                 onChange={(e) => setFormCar({ ...formCar, post: e.target.value })}
//                 style={{
//                   width: "95%", border: "1px solid #ccc", borderRadius: 6,
//                   padding: "8px", marginBottom: 15
//                 }}
//               />

//               <label>Years of Experience</label>
//               <input
//                 type="number"
//                 value={formCar.experience}
//                 required
//                 onChange={(e) => setFormCar({ ...formCar, experience: e.target.value })}
//                 style={{
//                   width: "95%", border: "1px solid #ccc", borderRadius: 6,
//                   padding: "8px", marginBottom: 15
//                 }}
//               />

//               <label>Description</label>
//               <textarea
//                 value={formCar.description}
//                 required
//                 onChange={(e) => setFormCar({ ...formCar, description: e.target.value })}
//                 style={{
//                   width: "95%", border: "1px solid #ccc", borderRadius: 6,
//                   padding: "8px", marginBottom: 15
//                 }}
//               />

// <h4>Job Sections</h4>

// {Array.isArray(formCar.sections) &&
//   formCar.sections.map((section, index) => (
//   <div key={index} style={{ marginBottom: 15, border: "1px solid #ddd", padding: 10, borderRadius: 6 }}>
    
//     <input
//       type="text"
//       placeholder="Heading (e.g. Key Skills, Work Experience)"
//       value={section.heading}
//       onChange={(e) => updateSection(index, "heading", e.target.value)}
//       style={{ width: "100%", marginBottom: 8, padding: 6 }}
//       required
//     />

//     <textarea
//       placeholder="Content"
//       value={section.content}
//       onChange={(e) => updateSection(index, "content", e.target.value)}
//       style={{ width: "100%", minHeight: 100, padding: 6 }}
//       required
//     />

//     <button
//       type="button"
//       onClick={() => removeSection(index)}
//       style={{ marginTop: 6, background: "red", color: "#fff", border: "none", padding: "4px 8px" }}
//     >
//       Delete Section
//     </button>
//   </div>
// ))}
// <div style={{ marginBottom: 20 }}>
// <button
//   type="button"
//   onClick={addSection}
//   style={{ marginBottom: 20, background: "#132e55", color: "#fff", padding: "6px 10px", border: "none" }}
// >
//   + Add Section
// </button>
// </div>

//               <label>No. of Vacancies</label>
//               <input
//                 type="number"
//                 value={formCar.vacancies}
//                 required
//                 onChange={(e) => setFormCar({ ...formCar, vacancies: e.target.value })}
//                 style={{
//                   width: "95%", border: "1px solid #ccc", borderRadius: 6,
//                   padding: "8px", marginBottom: 15
//                 }}
//               />

//               <button
//                 type="submit"
//                 style={{
//                   background: "var(--primary)",
//                   color: "#fff",
//                   width: "100%",
//                   padding: "10px",
//                   borderRadius: 6,
//                   fontSize: 15,
//                   border: "none",
//                   cursor: "pointer"
//                 }}
//               >
//                 {editingCar ? "Update" : "Add"}
//               </button>

//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }


//   if (activeComponent === "Why Choose Cards") 

//   return (
//  <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
//   <h2 style={{ color: "var(--primary)" }}>Why Choose Cards</h2>

//   {/* Add / Edit Form */}
//   <form onSubmit={handleSubmitWc} style={{ marginTop: 15 }}>
//     <input
//       type="text"
//       placeholder="Name"
//       value={formWc.name}
//       onChange={(e) => setFormWc({ ...formWc, name: e.target.value })}
//       style={{
//         width: "300px",
//         border: "1px solid #ccc",
//         borderRadius: 6,
//         padding: "8px",
//         margin: 15,
//         marginLeft: 0,
//       }}
//     />

//     <input
//       type="text"
//       placeholder="Status"
//       value={formWc.status}
//       onChange={(e) => setFormWc({ ...formWc, status: e.target.value })}
//       style={{
//         width: "300px",
//         border: "1px solid #ccc",
//         borderRadius: 6,
//         padding: "8px",
//         margin: 15,
//       }}
//     />

//     <button type="submit" style={btnStyle}>
//       {editingWc ? "Update" : "Add New"}
//     </button>
//   </form>

//   {/* Table */}
//   <table style={tableStyle}>
//     <thead style={theadStyle}>
//       <tr>
//         <th>#</th>
//         <th>Name</th>
//         <th>Status</th>
//         <th>Actions</th>
//       </tr>
//     </thead>

//     <tbody>
//       {cards.map((c, i) => (
//         <tr key={c.id}>
//           <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{i + 1}</td>
//           <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{c.name}</td>
//           <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{c.status}</td>

//           <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
//             <button onClick={() => handleEditWc(c)} style={editBtn}>
//               <FaEdit />
//             </button>

//             <button onClick={() => handleDeleteWc(c.id)} style={deleteBtn}>
//               <FaTrash />
//             </button>
//           </td>
//         </tr>
//       ))}
//     </tbody>
//   </table>
// </div>

//   );

//     return (
//    <div style={contentStyles.wrapper}>
//   <h2 style={contentStyles.title}>Welcome, {adminEmail}</h2>
//   <p style={contentStyles.subtitle}>This is your admin dashboard home.</p>
// </div>

//     );
//   };

//   return (
//     <div style={baseStyles.container}>
//       {/* Sidebar */}
//       <div
//         style={{
//           ...baseStyles.sidebar,
//           width: sidebarOpen ? "200px" : "70px",
//         }}
//       >
//         <div style={baseStyles.logoArea}>
//           {sidebarOpen ? (
//             <div style={baseStyles.logoBlock}>
//                   <span style={baseStyles.logoMain}>INFOSIGHT</span>
 
         
         
//             </div>
//           ) : (
//             <span style={baseStyles.logoMain}>I</span>
//           )}
//         </div>

//         <nav style={{ marginTop: "20px" }}>
//           {allNavItems.map((item) => (
//             <div
//               key={item.label}
//               style={{
//                 ...baseStyles.navItem,
//                 backgroundColor:
//                   activeComponent === item.label
//                     ? "rgba(255,255,255,0.15)"
//                     : "transparent",
//                 color:
//                   activeComponent === item.label ? "var(--accent)" : "#fff",
//               }}
//               onClick={() => setActiveComponent(item.label)}
//             >
//               <div style={baseStyles.navIcon}>{item.icon}</div>
//               {sidebarOpen && (
//                 <span style={baseStyles.navLabel}>{item.label}</span>
//               )}
//             </div>
//           ))}
//         </nav>
//       </div>

//       {/* Main Area */}
//       <div style={baseStyles.mainArea(sidebarOpen)}>
//         <div style={headerStyles.header}>
//           <div style={headerStyles.leftGroup}>
//             <button onClick={toggleSidebar} style={headerStyles.toggleBtn}>
//               <FaBars color="#fff" />
//             </button>
//           </div>

//           <div style={headerStyles.profileArea} ref={profileMenuRef}>
//             <FaUserCircle
//               size={30}
//               style={{ cursor: "pointer", color: "#fff" }}
//               onClick={() => setShowProfileMenu((p) => !p)}
//             />
//             {showProfileMenu && (
//               <div style={headerStyles.profileMenu}>
//                 <div
//                   style={headerStyles.profileMenuItem}
//                   onClick={handleLogout}
//                 >
//                   <FaSignOutAlt style={{ marginRight: 8 }} /> Logout
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>

//         <div style={baseStyles.contentWrapper}>{renderContent()}</div>
//       </div>
//     </div>
//   );
// };

// export default AdminDashboard;

// /* ---------- Styles ---------- */

// const baseStyles = {
//   container: {
//     display: "flex",
//     height: "100vh",
//     fontFamily: "Segoe UI, sans-serif",
//     background: "var(--bg-light)",
//   },
//   sidebar: {
//     background: "linear-gradient(180deg, var(--primary) 0%, #132e55 100%)",
//     color: "#fff",
//     transition: "width 0.3s ease",
//     position: "fixed",
//     top: 0,
//     bottom: 0,
//     left: 0,
//     padding: "15px 10px",
//     boxShadow: "4px 0 20px rgba(0,0,0,0.15)",
//      overflowY: "auto",
//   },
//   logoArea: {
//     textAlign: "center",
//     marginBottom: "1rem",
//   },
//   logoBlock: { lineHeight: 1.2 },
//   logoMain: {
//     fontWeight: "800",
//     color: "#fff",
//     fontSize: "1.3rem",
//     letterSpacing: "0.5px",
//         marginRight: "12px",
//   },
//   logoAccent: {
//     color: "var(--accent)",
//     fontWeight: "700",
//     fontSize: "1.1rem",
//     marginLeft: "4px",
//   },
//   logoTagline: {
//     fontSize: "0.7rem",
//     color: "#c9d1d9",
//     marginTop: "3px",
//   },
//   navItem: {
//     display: "flex",
//     alignItems: "center",
//     padding: "12px 14px",
//     marginBottom: "8px",
//     borderRadius: "6px",
//     cursor: "pointer",
//     transition: "background 0.3s, transform 0.2s",
//   },
//   navIcon: { fontSize: "18px", marginRight: "10px" },
//   navLabel: { fontSize: "15px", fontWeight: "500" },
//   mainArea: (sidebarOpen) => ({
//     marginLeft: sidebarOpen ? "220px" : "70px",
//     transition: "margin-left 0.3s ease",
//     width: "100%",
//     display: "flex",
//     flexDirection: "column",
//   }),
//   contentWrapper: {
//     flex: 1,
//     padding: "20px",
//     overflowY: "auto",
//   },
// };

// const headerStyles = {
//   header: {
//     height: "60px",
//     background: "linear-gradient(90deg, var(--primary), #132e55)",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     padding: "0 20px",
//     boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
//   },
//   leftGroup: { display: "flex", alignItems: "center" },
//   toggleBtn: {
//     background: "transparent",
//     border: "none",
//     cursor: "pointer",
//     fontSize: "20px",
//   },
//   profileArea: { position: "relative" },
//   profileMenu: {
//     position: "absolute",
//     right: 0,
//     top: "calc(100% + 10px)",
//     background: "#fff",
//     borderRadius: "8px",
//     boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
//     zIndex: 100,
//   },
//   profileMenuItem: {
//     padding: "10px 20px",
//     cursor: "pointer",
//     color: "var(--primary)",
//     fontWeight: 500,
//     borderBottom: "1px solid #eee",
//   },
// };

// const contentStyles = {
//  wrapper: {
//     background: "linear-gradient(135deg, var(--white), var(--light))",
//     borderRadius: "18px",
//     padding: "35px",
//     boxShadow:
//       "0 14px 30px rgba(0,0,0,0.12), 0 4px 12px rgba(0,0,0,0.06)",
//     border: "1px solid rgba(255, 255, 255, 0.7)",
//     backdropFilter: "blur(8px)",
//     transition: "0.3s ease-in-out",
//   },

//   title: {
//     margin: 0,
//     marginBottom: "14px",
//     fontSize: "1.9rem",
//     fontWeight: "700",
//     letterSpacing: "0.6px",
//     background: "linear-gradient(90deg, #e40613, #b30511)",
//     WebkitBackgroundClip: "text",
//     WebkitTextFillColor: "transparent",
//   },

//   subtitle: {
//     margin: 0,
//     marginTop: "5px",
//     fontSize: "1rem",
//     color: "#555",
//     fontWeight: "500",
//     opacity: 0.85,
//   },
//   formRow: { display: "flex", gap: "10px", marginBottom: "20px" },
//   input: {
//     padding: "10px",
//     borderRadius: "6px",
//     border: "1px solid #ccc",
//     flex: "0.3",
//   },
//   fileInput: {
//     flex: "0.5",
//     padding: "10px",
//     border: "1px solid #ccc",
//     borderRadius: "6px",
//   },
//   addBtn: {
//     background: "var(--accent)",
//     color: "#fff",
//     border: "none",
//     borderRadius: "6px",
//     padding: "10px 20px",
//     fontWeight: "600",
//     display: "flex",
//     alignItems: "center",
//     cursor: "pointer",
//     transition: "background 0.3s, transform 0.2s",
//   },
//   table: {
//     width: "100%",
//     borderCollapse: "collapse",
//     borderRadius: "8px",
//     overflow: "hidden",
//   },
//   thead: { background: "var(--primary)", color: "#fff" },
//   th: {
//     textAlign: "left",
//     padding: "10px",
//     fontWeight: "600",
//   },
//   td: { padding: "10px", borderBottom: "1px solid #eee" },
//   btnEdit: {
//     background: "var(--primary)",
//     color: "#fff",
//     border: "none",
//     borderRadius: "4px",
//     padding: "6px 10px",
//     marginRight: "6px",
//     cursor: "pointer",
//   },
//   btnDelete: {
//     background: "var(--accent)",
//     color: "#fff",
//     border: "none",
//     borderRadius: "4px",
//     padding: "6px 10px",
//     cursor: "pointer",
//   },
//   noData: { color: "#888", textAlign: "center", padding: "20px" },
// };


// // Common Styles
// const tdStyle = {
//   textAlign: "center",
//   border: "1px solid #ddd",
//   padding: "8px",
// };

// const modalBackdrop = {
//   position: "fixed",
//   inset: 0,
//   background: "rgba(0,0,0,0.4)",
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
//   zIndex: 1000,
//   backdropFilter: "blur(3px)",
// };

// const modalBox = {
//   background: "#fff",
//   borderRadius: 14,
//   width: "90%",
//   maxWidth: 520,
//   padding: "25px 30px 35px",
//   boxShadow: "0 8px 25px rgba(0,0,0,0.2)",
//   position: "relative",
//   animation: "fadeIn 0.4s ease",
//   overflowY: "auto",
//   maxHeight: "90vh",
// };

// const modalHeader = {
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
//   background: "linear-gradient(90deg, #7B1E3A, #F2C94C)",
//   padding: "12px 20px",
//   borderRadius: "10px 10px 0 0",
// };


// const inputStyle = {
//   width:"95%",
//   border:"1px solid #ccc",
//   borderRadius:6,
//   padding:"8px",
//   fontSize:14,
//   marginBottom:15
// };

// const btnStyle = {
//   background:"var(--primary)",
//   color:"#fff",
//   padding:"8px 15px",
//   border:"none",
//   borderRadius:6,
//   cursor:"pointer"
// };

// const tableStyle = {
//   width:"100%",
//   marginTop:20,
//   border:"1px solid #ddd"
// };

// const theadStyle = {
//   background:"var(--primary)",
//   color:"#fff"
// };

// const editBtn = {
//   background:"var(--primary)",
//   color:"#fff",
//   marginRight:6,
//   cursor:"pointer"
// };

// const deleteBtn = {
//   background:"var(--accent)",
//   color:"#132e55",
//   cursor:"pointer"
// };



import React, { useEffect, useState, useRef } from "react";
import {
  FaSignOutAlt,
  FaBars,
  FaUserCircle,
  FaEdit,
  FaTrash,
  FaPlus,
  FaTimes,
  FaCheck,
  FaSearch,
} from "react-icons/fa";
import {
  MdApps,
  MdAssignment,
  MdBuild,
  MdBusinessCenter,
  MdContactMail,
  MdDashboard,
  MdInsertChart,
  MdPerson,
  MdSlideshow,
  MdStar,
  MdWork,
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = "https://api.info-sight.net";

const APII = "http://localhost:15503";

// Modern Eye-Comfort Color Palette & Design Tokens
const theme = {
  bgApp: "#F8FAFC",
  bgSurface: "#FFFFFF",
  bgSubtle: "#F1F5F9",
  textPrimary: "#1E293B",
  textSecondary: "#64748B",
  textLight: "#94A3B8",
  primary: "#2C3E50",
  primaryHover: "#1E293B",
  accent: "#0D9488",
  accentLight: "#CCFBF1",
  danger: "#E11D48",
  dangerLight: "#FFE4E6",
  border: "#E2E8F0",
  shadowSm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
  shadowMd: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  shadowLg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  radius: "10px",
};

// Global Responsive CSS Injection
const globalStyles = `
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { background-color: ${theme.bgApp}; color: ${theme.textPrimary}; fontFamily: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; }
  
  .table-responsive {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    border-radius: ${theme.radius};
    border: 1px solid ${theme.border};
  }
  
  table { width: 100%; border-collapse: collapse; text-align: left; }
  th { background-color: ${theme.bgSubtle}; color: ${theme.textPrimary}; font-weight: 600; font-size: 0.85rem; padding: 12px 16px; border-bottom: 1px solid ${theme.border}; text-transform: uppercase; letter-spacing: 0.05em; }
  td { padding: 12px 16px; border-bottom: 1px solid ${theme.border}; color: ${theme.textSecondary}; font-size: 0.9rem; vertical-align: middle; }
  tr:last-child td { border-bottom: none; }
  tr:hover { background-color: #F8FAFC; }

  .mobile-overlay {
    display: none;
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.4);
    backdrop-filter: blur(4px);
    z-index: 40;
  }

  @media (max-width: 768px) {
    .mobile-overlay.show { display: block; }
    .sidebar-drawer {
      transform: translateX(-100%);
      transition: transform 0.3s ease-in-out;
    }
    .sidebar-drawer.open {
      transform: translateX(0);
    }
  }
`;

const AdminDashboard = () => {
  const adminEmail = sessionStorage.getItem("adminEmail") || "Admin";
  const navigate = useNavigate();

  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 768);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [activeComponent, setActiveComponent] = useState(
    localStorage.getItem("activeComponent") || "Dashboard"
  );
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const profileMenuRef = useRef(null);

  // Resize handler for full responsiveness
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) setSidebarOpen(true);
      else setSidebarOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    localStorage.setItem("activeComponent", activeComponent);
  }, [activeComponent]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (profileMenuRef.current && !profileMenuRef.current.contains(e.target)) {
        setShowProfileMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    sessionStorage.removeItem("isAdminLoggedIn");
    sessionStorage.removeItem("adminEmail");
    navigate("/admin-login");
  };

  // --- Projects State & Handlers --- //
  const [projects, setProjects] = useState([]);
  const [formP, setFormP] = useState({
    name: "",
    category: "Hospitality",
    country: "United Arab Emirates",
    scope_of_work: "",
    description: "",
    image: null,
  });
  const [editingP, setEditingP] = useState(null);
  const [showModalP, setShowModalP] = useState(false);
  const [currentPageP, setCurrentPageP] = useState(1);
  const itemsPerPageP = 8;

  const fetchProjects = async () => {
    try {
      const { data } = await axios.get(`${API}/api/projects`);
      setProjects(data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSubmitP = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("name", formP.name);
    data.append("category", formP.category);
    data.append("country", formP.country);
    data.append("scope_of_work", formP.scope_of_work);
    data.append("description", formP.description);
    if (formP.image instanceof File) data.append("image", formP.image);


    if (editingP) {
      await axios.put(`${API}/api/projects/${editingP}`, data);
    } else {
      await axios.post(`${API}/api/projects`, data);
    }
    setShowModalP(false);
    setFormP({ name: "", category: "Hospitality", country: "United Arab Emirates", scope_of_work: "", description: "", image: null });
    setEditingP(null);
    fetchProjects();
  };

  const handleEditP = (p) => {
    setFormP({ name: p.name, category: p.category, country: p.country, scope_of_work: p.scope_of_work || "", description: p.description || "", image: p.image });
    setEditingP(p.id);
    setShowModalP(true);
  };

  const handleDeleteP = async (id) => {
    if (window.confirm("Delete this project?")) {
      await axios.delete(`${API}/api/projects/${id}`);
      fetchProjects();
    }
  };

  // --- Hero Sliders State & Handlers --- //
  const [sliders, setSliders] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ title: "", location: "", image: null, order_no: "" });
  const [editingID, setEditingID] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  const fetchSliders = async () => {
    try {
      const { data } = await axios.get(`${API}/api/hero-sliders`);
      setSliders(data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const fd = new FormData();
    fd.append("title", form.title);
    fd.append("location", form.location);
    if (form.image instanceof File) fd.append("image", form.image);
    fd.append("order_no", form.order_no);

    if (editingID) {
      await axios.put(`${API}/api/hero-sliders/${editingID}`, fd);
    } else {
      await axios.post(`${API}/api/hero-sliders`, fd);
    }
    setShowModal(false);
    setEditingID(null);
    setForm({ title: "", location: "", image: null, order_no: "" });
    fetchSliders();
  };

  const handleEdit = (slide) => {
    setEditingID(slide.id);
    setForm({ title: slide.title, location: slide.location, image: slide.image, order_no: slide.order_no });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Delete this slide?")) {
      await axios.delete(`${API}/api/hero-sliders/${id}`);
      fetchSliders();
    }
  };

  // --- Job Applications State --- //
  const [applications, setApplications] = useState([]);
  const [currentPageA, setCurrentPageA] = useState(1);
  const itemsPerPageA = 8;

  const fetchApplications = async () => {
    try {
      const { data } = await axios.get(`${API}/api/applications`);
      setApplications(data);
    } catch (err) {
      console.error(err);
    }
  };

  // --- Services Menus State & Handlers --- //
  const [menus, setMenus] = useState([]);
  const [menuName, setMenuName] = useState("");
  const [editingIDSm, setEditingIDSm] = useState(null);
  const [currentPageSm, setCurrentPageSm] = useState(1);
  const itemsPerPageSm = 8;

  const fetchMenus = async () => {
    try {
      const { data } = await axios.get(`${API}/api/services-menus`);
      setMenus(data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSubmitMenu = async (e) => {
    e.preventDefault();
    if (!menuName.trim()) return;

    if (editingIDSm) {
      await axios.put(`${API}/api/services-menus/${editingIDSm}`, { menu_name: menuName });
    } else {
      await axios.post(`${API}/api/services-menus`, { menu_name: menuName });
    }
    setMenuName("");
    setEditingIDSm(null);
    fetchMenus();
  };

  const handleDeleteMenu = async (id) => {
    if (window.confirm("Delete this menu?")) {
      await axios.delete(`${API}/api/services-menus/${id}`);
      fetchMenus();
    }
  };

  // // --- Services State & Handlers --- //
  // const [services, setServices] = useState([]);
  // const [formS, setFormS] = useState({ menu_id: "", image: null, heading: "", paragraph: "", bullet_points: "" });
  // const [editingS, setEditingS] = useState(null);
  // const [showModalS, setShowModalS] = useState(false);
  // const [currentPageS, setCurrentPageS] = useState(1);
  // const itemsPerPageS = 8;

  // const fetchServices = async () => {
  //   try {
  //     const { data } = await axios.get(`${API}/api/services`);
  //     setServices(data);
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  // const handleSubmitS = async (e) => {
  //   e.preventDefault();
  //   const data = new FormData();
  //   data.append("menu_id", formS.menu_id);
  //   data.append("paragraph", formS.paragraph);
  //   data.append("heading", formS.heading);
  //   data.append(
  //     "bullet_points",
  //     JSON.stringify(formS.bullet_points.split("\n").filter((x) => x.trim() !== ""))
  //   );
  //   if (formS.image instanceof File) data.append("image", formS.image);

  //   if (editingS) {
  //     await axios.put(`${API}/api/services/${editingS}`, data);
  //   } else {
  //     await axios.post(`${API}/api/services`, data);
  //   }
  //   setShowModalS(false);
  //   setEditingS(null);
  //   setFormS({ menu_id: "", image: null, paragraph: "", heading: "", bullet_points: "" });
  //   fetchServices();
  // };

  // const handleEditS = (service) => {
  //   let bullets = "";
  //   try {
  //     bullets = service.bullet_points ? JSON.parse(service.bullet_points).join("\n") : "";
  //   } catch {
  //     bullets = service.bullet_points || "";
  //   }
  //   setFormS({
  //     menu_id: service.menu_id,
  //     image: service.image,
  //     heading: service.heading,
  //     paragraph: service.paragraph,
  //     bullet_points: bullets,
  //   });
  //   setEditingS(service.id);
  //   setShowModalS(true);
  // };

  // const handleDeleteS = async (id) => {
  //   if (window.confirm("Delete this service?")) {
  //     await axios.delete(`${API}/api/services/${id}`);
  //     fetchServices();
  //   }
  // };

// --- Services State & Handlers --- //
const [services, setServices] = useState([]);
const [formS, setFormS] = useState({
  menu_id: "",
  image: null,
  heading: "",
  paragraph: "",
  bullet_points: "",
  paragraph_highlights: "",
});
const [editingS, setEditingS] = useState(null);
const [showModalS, setShowModalS] = useState(false);
const [currentPageS, setCurrentPageS] = useState(1);
const itemsPerPageS = 8;

const fetchServices = async () => {
  try {
    const { data } = await axios.get(`${API}/api/services`);
    setServices(data);
  } catch (err) {
    console.error(err);
  }
};

const handleSubmitS = async (e) => {
  e.preventDefault();
  const data = new FormData();
  data.append("menu_id", formS.menu_id);
  data.append("paragraph", formS.paragraph);
  data.append("heading", formS.heading);
  data.append(
    "bullet_points",
    JSON.stringify(formS.bullet_points.split("\n").filter((x) => x.trim() !== ""))
  );
  // Parses line-by-line highlights preserving exact case
  data.append(
    "paragraph_highlights",
    JSON.stringify(formS.paragraph_highlights.split("\n").filter((x) => x.trim() !== ""))
  );
  if (formS.image instanceof File) data.append("image", formS.image);

  if (editingS) {
    await axios.put(`${API}/api/services/${editingS}`, data);
  } else {
    await axios.post(`${API}/api/services`, data);
  }
  setShowModalS(false);
  setEditingS(null);
  setFormS({
    menu_id: "",
    image: null,
    paragraph: "",
    heading: "",
    bullet_points: "",
    paragraph_highlights: "",
  });
  fetchServices();
};

const handleEditS = (service) => {
  let bullets = "";
  try {
    bullets = service.bullet_points ? JSON.parse(service.bullet_points).join("\n") : "";
  } catch {
    bullets = service.bullet_points || "";
  }

  let highlights = "";
  try {
    highlights = service.paragraph_highlights ? JSON.parse(service.paragraph_highlights).join("\n") : "";
  } catch {
    highlights = service.paragraph_highlights || "";
  }

  setFormS({
    menu_id: service.menu_id,
    image: service.image,
    heading: service.heading,
    paragraph: service.paragraph,
    bullet_points: bullets,
    paragraph_highlights: highlights,
  });
  setEditingS(service.id);
  setShowModalS(true);
};

const handleDeleteS = async (id) => {
  if (window.confirm("Delete this service?")) {
    await axios.delete(`${API}/api/services/${id}`);
    fetchServices();
  }
};


  // --- Clients State --- //
  const [clients, setClients] = useState([]);
  const [formC, setFormC] = useState({ client_name: "", image: null });
  const [editingC, setEditingC] = useState(null);

  const fetchClients = async () => {
    try {
      const { data } = await axios.get(`${API}/api/clients`);
      setClients(data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSubmitC = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("client_name", formC.client_name);
    if (formC.image instanceof File) data.append("image", formC.image);

    if (editingC) {
      await axios.put(`${API}/api/clients/${editingC}`, data);
    } else {
      await axios.post(`${API}/api/clients`, data);
    }
    setEditingC(null);
    setFormC({ client_name: "", image: null });
    fetchClients();
  };

  const handleDeleteC = async (id) => {
    if (window.confirm("Delete this client?")) {
      await axios.delete(`${API}/api/clients/${id}`);
      fetchClients();
    }
  };

  // --- Careers State --- //
  const [careers, setCareers] = useState([]);
  const [formCar, setFormCar] = useState({ post: "", experience: "", description: "", sections: [], vacancies: "" });
  const [editingCar, setEditingCar] = useState(null);
  const [showModalCar, setShowModalCar] = useState(false);
  const [currentPageCar, setCurrentPageCar] = useState(1);
  const itemsPerPageCar = 8;

  const fetchCareers = async () => {
    try {
      const { data } = await axios.get(`${API}/api/careers`);
      setCareers(data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSubmitCar = async (e) => {
    e.preventDefault();
    if (editingCar) {
      await axios.put(`${API}/api/careers/${editingCar}`, formCar);
    } else {
      await axios.post(`${API}/api/careers`, formCar);
    }
    setShowModalCar(false);
    setEditingCar(null);
    setFormCar({ post: "", experience: "", description: "", sections: [], vacancies: "" });
    fetchCareers();
  };

  const handleDeleteCar = async (id) => {
    if (window.confirm("Delete this career?")) {
      await axios.delete(`${API}/api/careers/${id}`);
      fetchCareers();
    }
  };

  // --- Status Cards & Why Choose Cards --- //
  const [statusCards, setStatusCards] = useState([]);
  const [formSC, setFormSC] = useState({ name: "", count: "" });
  const [editingSC, setEditingSC] = useState(null);

  const [cards, setCards] = useState([]);
  const [formWc, setFormWc] = useState({ name: "", status: "" });
  const [editingWc, setEditingWc] = useState(null);

  const [contacts, setContacts] = useState([]);
  const [currentPageF, setCurrentPageF] = useState(1);
  const itemsPerPageF = 8;

  const fetchStatusCards = async () => {
    try {
      const { data } = await axios.get(`${API}/api/status-cards`);
      setStatusCards(data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchCards = async () => {
    try {
      const { data } = await axios.get(`${API}/api/why-choose-cards`);
      setCards(data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchContacts = async () => {
    try {
      const { data } = await axios.get(`${API}/api/contacts`);
      setContacts(data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchProjects();
    fetchSliders();
    fetchApplications();
    fetchMenus();
    fetchServices();
    fetchClients();
    fetchCareers();
    fetchStatusCards();
    fetchCards();
    fetchContacts();
  }, []);

  const navItems = [
    { label: "Dashboard", icon: <MdDashboard /> },
    { label: "Hero Sliders", icon: <MdSlideshow /> },
    { label: "Projects", icon: <MdWork /> },
    { label: "Services Menus", icon: <MdApps /> },
    { label: "Services", icon: <MdBuild /> },
    { label: "Clients", icon: <MdPerson /> },
    { label: "Contact Forms", icon: <MdContactMail /> },
    { label: "Careers", icon: <MdBusinessCenter /> },
    { label: "Job Applications", icon: <MdAssignment /> },
    { label: "Status Cards", icon: <MdInsertChart /> },
    { label: "Why Choose Cards", icon: <MdStar /> },
  ];

  // Helper Pagination Renderer
  const renderPagination = (current, total, setPage) => {
    if (total <= 1) return null;
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "8px", marginTop: "20px" }}>
        <button
          disabled={current === 1}
          onClick={() => setPage(current - 1)}
          style={{ ...uiStyles.btnSecondary, opacity: current === 1 ? 0.5 : 1, cursor: current === 1 ? "not-allowed" : "pointer" }}
        >
          Prev
        </button>
        {Array.from({ length: total }, (_, i) => i + 1).map((p) => (
          <button
            key={p}
            onClick={() => setPage(p)}
            style={{
              padding: "6px 12px",
              borderRadius: "6px",
              border: `1px solid ${p === current ? theme.primary : theme.border}`,
              backgroundColor: p === current ? theme.primary : theme.bgSurface,
              color: p === current ? "#fff" : theme.textPrimary,
              fontWeight: p === current ? "600" : "normal",
              cursor: "pointer",
            }}
          >
            {p}
          </button>
        ))}
        <button
          disabled={current === total}
          onClick={() => setPage(current + 1)}
          style={{ ...uiStyles.btnSecondary, opacity: current === total ? 0.5 : 1, cursor: current === total ? "not-allowed" : "pointer" }}
        >
          Next
        </button>
      </div>
    );
  };

  const renderContent = () => {
    // --- DASHBOARD HOME ---
    if (activeComponent === "Dashboard") {
      return (
        <div style={uiStyles.card}>
          <h2 style={uiStyles.heading}>Overview</h2>
          <p style={{ color: theme.textSecondary, marginBottom: "20px" }}>Welcome back, {adminEmail}</p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "16px" }}>
            <div style={uiStyles.statCard}>
              <span style={uiStyles.statLabel}>Total Projects</span>
              <span style={uiStyles.statValue}>{projects.length}</span>
            </div>
            <div style={uiStyles.statCard}>
              <span style={uiStyles.statLabel}>Job Applications</span>
              <span style={uiStyles.statValue}>{applications.length}</span>
            </div>
            <div style={uiStyles.statCard}>
              <span style={uiStyles.statLabel}>Active Services</span>
              <span style={uiStyles.statValue}>{services.length}</span>
            </div>
            <div style={uiStyles.statCard}>
              <span style={uiStyles.statLabel}>Client Partners</span>
              <span style={uiStyles.statValue}>{clients.length}</span>
            </div>
          </div>
        </div>
      );
    }

    // --- PROJECTS ---
    if (activeComponent === "Projects") {
      const totalPages = Math.ceil(projects.length / itemsPerPageP);
      const items = projects.slice((currentPageP - 1) * itemsPerPageP, currentPageP * itemsPerPageP);

      return (
        <div style={uiStyles.card}>
          <div style={uiStyles.cardHeader}>
            <h2 style={uiStyles.heading}>Projects</h2>
            <button onClick={() => { setFormP({ name: "", category: "Hospitality", country: "United Arab Emirates", scope_of_work: "", description: "", image: null }); setEditingP(null); setShowModalP(true); }} style={uiStyles.btnPrimary}>
              <FaPlus style={{ marginRight: 6 }} /> Add Project
            </button>
          </div>

          <div className="table-responsive">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Category</th>
                  <th>Country</th>
                  <th>Scope</th>
                  <th>Image</th>
                  <th style={{ textAlign: "right" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {items.map((p, i) => (
                  <tr key={p.id}>
                    <td>{(currentPageP - 1) * itemsPerPageP + i + 1}</td>
                    <td style={{ fontWeight: 600, color: theme.textPrimary }}>{p.name}</td>
                    <td>{p.category}</td>
                    <td>{p.country}</td>
                    <td>{p.scope_of_work || "-"}</td>
                    <td><img src={p.image} alt="" style={{ width: 44, height: 44, borderRadius: 6, objectFit: "cover" }} /></td>
                    <td style={{ textAlign: "right" }}>
                      <button onClick={() => handleEditP(p)} style={uiStyles.btnIcon}><FaEdit /></button>
                      <button onClick={() => handleDeleteP(p.id)} style={uiStyles.btnIconDanger}><FaTrash /></button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {renderPagination(currentPageP, totalPages, setCurrentPageP)}

          {showModalP && (
            <div style={uiStyles.modalOverlay}>
              <div style={uiStyles.modalContent}>
                <div style={uiStyles.modalHeader}>
                  <h3>{editingP ? "Edit Project" : "Add Project"}</h3>
                  <FaTimes onClick={() => setShowModalP(false)} style={{ cursor: "pointer", color: theme.textSecondary }} />
                </div>
                <form onSubmit={handleSubmitP} style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                  <div>
                    <label style={uiStyles.label}>Project Name</label>
                    <input type="text" value={formP.name} onChange={(e) => setFormP({ ...formP, name: e.target.value })} required style={uiStyles.input} />
                  </div>
                  <div>
                    <label style={uiStyles.label}>Category</label>
                    <select value={formP.category} onChange={(e) => setFormP({ ...formP, category: e.target.value })} style={uiStyles.input}>
                      <option>Hospitality</option>
                      <option>Residential</option>
                      <option>Mixed Use</option>
                      <option>Corporate & Government</option>
                      <option>Recreational</option>
                    </select>
                  </div>
                  <div>
                    <label style={uiStyles.label}>Country</label>
                    <input type="text" value={formP.country} onChange={(e) => setFormP({ ...formP, country: e.target.value })} style={uiStyles.input} />
                  </div>
                  <div>
                    <label style={uiStyles.label}>Scope of Work</label>
                    <input type="text" value={formP.scope_of_work} onChange={(e) => setFormP({ ...formP, scope_of_work: e.target.value })} style={uiStyles.input} />
                  </div>
                  <div>
                    <label style={uiStyles.label}>Description</label>
                    <textarea rows={3} value={formP.description} onChange={(e) => setFormP({ ...formP, description: e.target.value })} style={uiStyles.input} />
                  </div>
                  <div>
                    <label style={uiStyles.label}>Image</label>
                    <input type="file" onChange={(e) => setFormP({ ...formP, image: e.target.files[0] })} style={uiStyles.input} />
                  </div>
                  <button type="submit" style={{ ...uiStyles.btnPrimary, marginTop: "10px" }}>
                    {editingP ? "Update" : "Save"}
                  </button>
                </form>
              </div>
            </div>
          )}
        </div>
      );
    }

    // --- HERO SLIDERS ---
    if (activeComponent === "Hero Sliders") {
      const totalPages = Math.ceil(sliders.length / itemsPerPage);
      const items = sliders.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

      return (
        <div style={uiStyles.card}>
          <div style={uiStyles.cardHeader}>
            <h2 style={uiStyles.heading}>Hero Sliders</h2>
            <button onClick={() => { setForm({ title: "", location: "", image: null, order_no: "" }); setEditingID(null); setShowModal(true); }} style={uiStyles.btnPrimary}>
              <FaPlus style={{ marginRight: 6 }} /> Add Slide
            </button>
          </div>

          <div className="table-responsive">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Title</th>
                  <th>Location</th>
                  <th>Order</th>
                  <th>Image</th>
                  <th style={{ textAlign: "right" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {items.map((slide, i) => (
                  <tr key={slide.id}>
                    <td>{(currentPage - 1) * itemsPerPage + i + 1}</td>
                    <td style={{ fontWeight: 600 }}>{slide.title}</td>
                    <td>{slide.location}</td>
                    <td>{slide.order_no}</td>
                    <td><img src={slide.image} alt="" style={{ width: 60, height: 36, borderRadius: 4, objectFit: "cover" }} /></td>
                    <td style={{ textAlign: "right" }}>
                      <button onClick={() => handleEdit(slide)} style={uiStyles.btnIcon}><FaEdit /></button>
                      <button onClick={() => handleDelete(slide.id)} style={uiStyles.btnIconDanger}><FaTrash /></button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {renderPagination(currentPage, totalPages, setCurrentPage)}

          {showModal && (
            <div style={uiStyles.modalOverlay}>
              <div style={uiStyles.modalContent}>
                <div style={uiStyles.modalHeader}>
                  <h3>{editingID ? "Edit Slide" : "Add Slide"}</h3>
                  <FaTimes onClick={() => setShowModal(false)} style={{ cursor: "pointer", color: theme.textSecondary }} />
                </div>
                <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                  <div>
                    <label style={uiStyles.label}>Title</label>
                    <input type="text" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} required style={uiStyles.input} />
                  </div>
                  <div>
                    <label style={uiStyles.label}>Location</label>
                    <input type="text" value={form.location} onChange={(e) => setForm({ ...form, location: e.target.value })} required style={uiStyles.input} />
                  </div>
                  <div>
                    <label style={uiStyles.label}>Order Number</label>
                    <input type="number" value={form.order_no} onChange={(e) => setForm({ ...form, order_no: e.target.value })} style={uiStyles.input} />
                  </div>
                  <div>
                    <label style={uiStyles.label}>Image</label>
                    <input type="file" onChange={(e) => setForm({ ...form, image: e.target.files[0] })} style={uiStyles.input} />
                  </div>
                  <button type="submit" style={{ ...uiStyles.btnPrimary, marginTop: "10px" }}>{editingID ? "Update" : "Save"}</button>
                </form>
              </div>
            </div>
          )}
        </div>
      );
    }

    // --- JOB APPLICATIONS ---
    if (activeComponent === "Job Applications") {
      const totalPages = Math.ceil(applications.length / itemsPerPageA);
      const items = applications.slice((currentPageA - 1) * itemsPerPageA, currentPageA * itemsPerPageA);

      return (
        <div style={uiStyles.card}>
          <h2 style={{ ...uiStyles.heading, marginBottom: "16px" }}>Applications</h2>
          <div className="table-responsive">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Job Title</th>
                  <th>Candidate</th>
                  <th>Email</th>
                  <th>Mobile</th>
                  <th>Resume</th>
                  <th>Applied On</th>
                </tr>
              </thead>
              <tbody>
                {items.map((app, i) => (
                  <tr key={app.id}>
                    <td>{(currentPageA - 1) * itemsPerPageA + i + 1}</td>
                    <td style={{ fontWeight: 600 }}>{app.job_title}</td>
                    <td>{app.name}</td>
                    <td>{app.email}</td>
                    <td>{app.mobile}</td>
                    <td>
                      <a href={app.resume_file} target="_blank" rel="noreferrer" style={{ color: theme.accent, fontWeight: 500 }}>
                        View Resume
                      </a>
                    </td>
                    <td>{new Date(app.created_at || Date.now()).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {renderPagination(currentPageA, totalPages, setCurrentPageA)}
        </div>
      );
    }

    // --- SERVICES MENUS ---
    if (activeComponent === "Services Menus") {
      return (
        <div style={uiStyles.card}>
          <h2 style={{ ...uiStyles.heading, marginBottom: "16px" }}>Services Categories</h2>
          <form onSubmit={handleSubmitMenu} style={{ display: "flex", gap: "10px", marginBottom: "20px", flexWrap: "wrap" }}>
            <input
              type="text"
              placeholder="Enter menu name"
              value={menuName}
              onChange={(e) => setMenuName(e.target.value)}
              style={{ ...uiStyles.input, maxWidth: "320px" }}
              required
            />
            <button type="submit" style={uiStyles.btnPrimary}>
              {editingIDSm ? "Update Menu" : "Add Category"}
            </button>
          </form>

          <div className="table-responsive">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Category Name</th>
                  <th style={{ textAlign: "right" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {menus.map((m, i) => (
                  <tr key={m.id}>
                    <td>{i + 1}</td>
                    <td style={{ fontWeight: 600 }}>{m.menu_name}</td>
                    <td style={{ textAlign: "right" }}>
                      <button onClick={() => { setMenuName(m.menu_name); setEditingIDSm(m.id); }} style={uiStyles.btnIcon}><FaEdit /></button>
                      <button onClick={() => handleDeleteMenu(m.id)} style={uiStyles.btnIconDanger}><FaTrash /></button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      );
    }

    // --- SERVICES ---
    // if (activeComponent === "Services") {
    //   const totalPages = Math.ceil(services.length / itemsPerPageS);
    //   const items = services.slice((currentPageS - 1) * itemsPerPageS, currentPageS * itemsPerPageS);

    //   return (
    //     <div style={uiStyles.card}>
    //       <div style={uiStyles.cardHeader}>
    //         <h2 style={uiStyles.heading}>Services Details</h2>
    //         <button onClick={() => { setFormS({ menu_id: "", image: null, heading: "", paragraph: "", bullet_points: "" }); setEditingS(null); setShowModalS(true); }} style={uiStyles.btnPrimary}>
    //           <FaPlus style={{ marginRight: 6 }} /> Add Service
    //         </button>
    //       </div>

    //       <div className="table-responsive">
    //         <table>
    //           <thead>
    //             <tr>
    //               <th>#</th>
    //               <th>Menu</th>
    //               <th>Heading</th>
    //               <th>Image</th>
    //               <th style={{ textAlign: "right" }}>Actions</th>
    //             </tr>
    //           </thead>
    //           <tbody>
    //             {items.map((s, i) => (
    //               <tr key={s.id}>
    //                 <td>{(currentPageS - 1) * itemsPerPageS + i + 1}</td>
    //                 <td>{s.menu_name || s.menu_id}</td>
    //                 <td style={{ fontWeight: 600 }}>{s.heading}</td>
    //                 <td><img src={s.image} alt="" style={{ width: 40, height: 40, borderRadius: 4, objectFit: "cover" }} /></td>
    //                 <td style={{ textAlign: "right" }}>
    //                   <button onClick={() => handleEditS(s)} style={uiStyles.btnIcon}><FaEdit /></button>
    //                   <button onClick={() => handleDeleteS(s.id)} style={uiStyles.btnIconDanger}><FaTrash /></button>
    //                 </td>
    //               </tr>
    //             ))}
    //           </tbody>
    //         </table>
    //       </div>
    //       {renderPagination(currentPageS, totalPages, setCurrentPageS)}

    //       {showModalS && (
    //         <div style={uiStyles.modalOverlay}>
    //           <div style={uiStyles.modalContent}>
    //             <div style={uiStyles.modalHeader}>
    //               <h3>{editingS ? "Edit Service" : "Add Service"}</h3>
    //               <FaTimes onClick={() => setShowModalS(false)} style={{ cursor: "pointer", color: theme.textSecondary }} />
    //             </div>
    //             <form onSubmit={handleSubmitS} style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
    //               <div>
    //                 <label style={uiStyles.label}>Menu Category</label>
    //                 <select value={formS.menu_id} onChange={(e) => setFormS({ ...formS, menu_id: e.target.value })} required style={uiStyles.input}>
    //                   <option value="">Select Menu</option>
    //                   {menus.map((m) => (<option key={m.id} value={m.id}>{m.menu_name}</option>))}
    //                 </select>
    //               </div>
    //               <div>
    //                 <label style={uiStyles.label}>Heading</label>
    //                 <input type="text" value={formS.heading} onChange={(e) => setFormS({ ...formS, heading: e.target.value })} style={uiStyles.input} />
    //               </div>
    //               <div>
    //                 <label style={uiStyles.label}>Paragraph</label>
    //                 <textarea rows={3} value={formS.paragraph} onChange={(e) => setFormS({ ...formS, paragraph: e.target.value })} style={uiStyles.input} />
    //               </div>
    //               <div>
    //                 <label style={uiStyles.label}>Bullet Points (One per line)</label>
    //                 <textarea rows={3} value={formS.bullet_points} onChange={(e) => setFormS({ ...formS, bullet_points: e.target.value })} style={uiStyles.input} />
    //               </div>
    //               <div>
    //                 <label style={uiStyles.label}>Image</label>
    //                 <input type="file" onChange={(e) => setFormS({ ...formS, image: e.target.files[0] })} style={uiStyles.input} />
    //               </div>
    //               <button type="submit" style={{ ...uiStyles.btnPrimary, marginTop: "10px" }}>{editingS ? "Update" : "Save"}</button>
    //             </form>
    //           </div>
    //         </div>
    //       )}
    //     </div>
    //   );
    // }

    // --- SERVICES VIEW ---
if (activeComponent === "Services") {
  const totalPages = Math.ceil(services.length / itemsPerPageS);
  const items = services.slice((currentPageS - 1) * itemsPerPageS, currentPageS * itemsPerPageS);

  return (
    <div style={uiStyles.card}>
      <div style={uiStyles.cardHeader}>
        <h2 style={uiStyles.heading}>Services Details</h2>
        <button
          onClick={() => {
            setFormS({
              menu_id: "",
              image: null,
              heading: "",
              paragraph: "",
              bullet_points: "",
              paragraph_highlights: "",
            });
            setEditingS(null);
            setShowModalS(true);
          }}
          style={uiStyles.btnPrimary}
        >
          <FaPlus style={{ marginRight: 6 }} /> Add Service
        </button>
      </div>

      <div className="table-responsive">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Menu</th>
              <th>Heading</th>
              <th>Image</th>
              <th style={{ textAlign: "right" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {items.map((s, i) => (
              <tr key={s.id}>
                <td>{(currentPageS - 1) * itemsPerPageS + i + 1}</td>
                <td>{s.menu_name || s.menu_id}</td>
                <td style={{ fontWeight: 600 }}>{s.heading}</td>
                <td>
                  <img
                    src={s.image}
                    alt=""
                    style={{ width: 40, height: 40, borderRadius: 4, objectFit: "cover" }}
                  />
                </td>
                <td style={{ textAlign: "right" }}>
                  <button onClick={() => handleEditS(s)} style={uiStyles.btnIcon}>
                    <FaEdit />
                  </button>
                  <button onClick={() => handleDeleteS(s.id)} style={uiStyles.btnIconDanger}>
                    <FaTrash />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {renderPagination(currentPageS, totalPages, setCurrentPageS)}

      {showModalS && (
        <div style={uiStyles.modalOverlay}>
          <div style={uiStyles.modalContent}>
            <div style={uiStyles.modalHeader}>
              <h3>{editingS ? "Edit Service" : "Add Service"}</h3>
              <FaTimes
                onClick={() => setShowModalS(false)}
                style={{ cursor: "pointer", color: theme.textSecondary }}
              />
            </div>
            <form onSubmit={handleSubmitS} style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              <div>
                <label style={uiStyles.label}>Menu Category</label>
                <select
                  value={formS.menu_id}
                  onChange={(e) => setFormS({ ...formS, menu_id: e.target.value })}
                  required
                  style={uiStyles.input}
                >
                  <option value="">Select Menu</option>
                  {menus.map((m) => (
                    <option key={m.id} value={m.id}>
                      {m.menu_name}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label style={uiStyles.label}>Heading</label>
                <input
                  type="text"
                  value={formS.heading}
                  onChange={(e) => setFormS({ ...formS, heading: e.target.value })}
                  style={uiStyles.input}
                />
              </div>
              <div>
                <label style={uiStyles.label}>Paragraph</label>
                <textarea
                  rows={3}
                  value={formS.paragraph}
                  onChange={(e) => setFormS({ ...formS, paragraph: e.target.value })}
                  style={uiStyles.input}
                />
              </div>
              <div>
                <label style={uiStyles.label}>Paragraph Highlights (Exact Case - One per line)</label>
                <textarea
                  rows={3}
                  placeholder="e.g.&#10;Building Acoustics services&#10;MEP systems"
                  value={formS.paragraph_highlights}
                  onChange={(e) => setFormS({ ...formS, paragraph_highlights: e.target.value })}
                  style={uiStyles.input}
                />
              </div>
              <div>
                <label style={uiStyles.label}>Bullet Points (One per line)</label>
                <textarea
                  rows={3}
                  value={formS.bullet_points}
                  onChange={(e) => setFormS({ ...formS, bullet_points: e.target.value })}
                  style={uiStyles.input}
                />
              </div>
              <div>
                <label style={uiStyles.label}>Image</label>
                <input
                  type="file"
                  onChange={(e) => setFormS({ ...formS, image: e.target.files[0] })}
                  style={uiStyles.input}
                />
              </div>
              <button type="submit" style={{ ...uiStyles.btnPrimary, marginTop: "10px" }}>
                {editingS ? "Update" : "Save"}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

    // --- CLIENTS ---
    if (activeComponent === "Clients") {
      return (
        <div style={uiStyles.card}>
          <h2 style={{ ...uiStyles.heading, marginBottom: "16px" }}>Clients</h2>
          <form onSubmit={handleSubmitC} style={{ display: "flex", gap: "12px", alignItems: "flex-end", marginBottom: "20px", flexWrap: "wrap" }}>
            <div style={{ flex: 1, minWidth: "200px" }}>
              <label style={uiStyles.label}>Client Name</label>
              <input type="text" value={formC.client_name} onChange={(e) => setFormC({ ...formC, client_name: e.target.value })} placeholder="Client Name" style={uiStyles.input} />
            </div>
            <div style={{ flex: 1, minWidth: "200px" }}>
              <label style={uiStyles.label}>Client Logo</label>
              <input type="file" onChange={(e) => setFormC({ ...formC, image: e.target.files[0] })} style={uiStyles.input} />
            </div>
            <button type="submit" style={uiStyles.btnPrimary}>{editingC ? "Update" : "Add Client"}</button>
          </form>

          <div className="table-responsive">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Image</th>
                  <th style={{ textAlign: "right" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {clients.map((c, i) => (
                  <tr key={c.id}>
                    <td>{i + 1}</td>
                    <td>{c.client_name || "-"}</td>
                    <td><img src={c.image} alt="" style={{ width: 50, height: 30, objectFit: "contain" }} /></td>
                    <td style={{ textAlign: "right" }}>
                      <button onClick={() => { setFormC({ client_name: c.client_name || "", image: c.image }); setEditingC(c.id); }} style={uiStyles.btnIcon}><FaEdit /></button>
                      <button onClick={() => handleDeleteC(c.id)} style={uiStyles.btnIconDanger}><FaTrash /></button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      );
    }

    // --- CONTACT FORMS ---
    if (activeComponent === "Contact Forms") {
      const totalPages = Math.ceil(contacts.length / itemsPerPageF);
      const items = contacts.slice((currentPageF - 1) * itemsPerPageF, currentPageF * itemsPerPageF);

      return (
        <div style={uiStyles.card}>
          <h2 style={{ ...uiStyles.heading, marginBottom: "16px" }}>Contact Submissions</h2>
          <div className="table-responsive">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Organization</th>
                  <th>Subject</th>
                  <th>Message</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {items.map((c, i) => (
                  <tr key={c.id}>
                    <td>{(currentPageF - 1) * itemsPerPageF + i + 1}</td>
                    <td style={{ fontWeight: 600 }}>{c.name}</td>
                    <td>{c.email}</td>
                    <td>{c.organization || "-"}</td>
                    <td>{c.subject}</td>
                    <td style={{ maxWidth: 200, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{c.message}</td>
                    <td>{new Date(c.createdAt || Date.now()).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {renderPagination(currentPageF, totalPages, setCurrentPageF)}
        </div>
      );
    }

    // --- CAREERS ---
    if (activeComponent === "Careers") {
      const totalPages = Math.ceil(careers.length / itemsPerPageCar);
      const items = careers.slice((currentPageCar - 1) * itemsPerPageCar, currentPageCar * itemsPerPageCar);

      return (
        <div style={uiStyles.card}>
          <div style={uiStyles.cardHeader}>
            <h2 style={uiStyles.heading}>Career Listings</h2>
            <button onClick={() => { setFormCar({ post: "", experience: "", description: "", vacancies: "", sections: [] }); setEditingCar(null); setShowModalCar(true); }} style={uiStyles.btnPrimary}>
              <FaPlus style={{ marginRight: 6 }} /> Add Opening
            </button>
          </div>

          <div className="table-responsive">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Role / Post</th>
                  <th>Experience</th>
                  <th>Vacancies</th>
                  <th style={{ textAlign: "right" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {items.map((c, i) => (
                  <tr key={c.id}>
                    <td>{(currentPageCar - 1) * itemsPerPageCar + i + 1}</td>
                    <td style={{ fontWeight: 600 }}>{c.post}</td>
                    <td>{c.experience} Yrs</td>
                    <td>{c.vacancies}</td>
                    <td style={{ textAlign: "right" }}>
                      <button onClick={() => { setFormCar(c); setEditingCar(c.id); setShowModalCar(true); }} style={uiStyles.btnIcon}><FaEdit /></button>
                      <button onClick={() => handleDeleteCar(c.id)} style={uiStyles.btnIconDanger}><FaTrash /></button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {renderPagination(currentPageCar, totalPages, setCurrentPageCar)}

          {showModalCar && (
            <div style={uiStyles.modalOverlay}>
              <div style={uiStyles.modalContent}>
                <div style={uiStyles.modalHeader}>
                  <h3>{editingCar ? "Edit Career" : "Add Career"}</h3>
                  <FaTimes onClick={() => setShowModalCar(false)} style={{ cursor: "pointer", color: theme.textSecondary }} />
                </div>
                <form onSubmit={handleSubmitCar} style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                  <div>
                    <label style={uiStyles.label}>Post Title</label>
                    <input type="text" value={formCar.post} onChange={(e) => setFormCar({ ...formCar, post: e.target.value })} required style={uiStyles.input} />
                  </div>
                  <div>
                    <label style={uiStyles.label}>Years Experience</label>
                    <input type="number" value={formCar.experience} onChange={(e) => setFormCar({ ...formCar, experience: e.target.value })} required style={uiStyles.input} />
                  </div>
                  <div>
                    <label style={uiStyles.label}>Vacancies</label>
                    <input type="number" value={formCar.vacancies} onChange={(e) => setFormCar({ ...formCar, vacancies: e.target.value })} required style={uiStyles.input} />
                  </div>
                  <div>
                    <label style={uiStyles.label}>Description</label>
                    <textarea rows={3} value={formCar.description} onChange={(e) => setFormCar({ ...formCar, description: e.target.value })} required style={uiStyles.input} />
                  </div>
                  <button type="submit" style={{ ...uiStyles.btnPrimary, marginTop: "10px" }}>{editingCar ? "Update" : "Save"}</button>
                </form>
              </div>
            </div>
          )}
        </div>
      );
    }

    // --- STATUS & WHY CHOOSE CARDS ---
    if (activeComponent === "Status Cards" || activeComponent === "Why Choose Cards") {
      const isStatus = activeComponent === "Status Cards";
      const listData = isStatus ? statusCards : cards;

      return (
        <div style={uiStyles.card}>
          <h2 style={{ ...uiStyles.heading, marginBottom: "16px" }}>{activeComponent}</h2>
          <form
            onSubmit={async (e) => {
              e.preventDefault();
              if (isStatus) {
                if (editingSC) await axios.put(`${API}/api/status-cards/${editingSC}`, formSC);
                else await axios.post(`${API}/api/status-cards`, formSC);
                setFormSC({ name: "", count: "" });
                setEditingSC(null);
                fetchStatusCards();
              } else {
                if (editingWc) await axios.put(`${API}/api/why-choose-cards/${editingWc}`, formWc);
                else await axios.post(`${API}/api/why-choose-cards`, formWc);
                setFormWc({ name: "", status: "" });
                setEditingWc(null);
                fetchCards();
              }
            }}
            style={{ display: "flex", gap: "12px", marginBottom: "20px", flexWrap: "wrap" }}
          >
            <input
              type="text"
              placeholder="Title/Name"
              value={isStatus ? formSC.name : formWc.name}
              onChange={(e) => (isStatus ? setFormSC({ ...formSC, name: e.target.value }) : setFormWc({ ...formWc, name: e.target.value }))}
              style={{ ...uiStyles.input, maxWidth: "240px" }}
              required
            />
            <input
              type="text"
              placeholder={isStatus ? "Count" : "Status text"}
              value={isStatus ? formSC.count : formWc.status}
              onChange={(e) => (isStatus ? setFormSC({ ...formSC, count: e.target.value }) : setFormWc({ ...formWc, status: e.target.value }))}
              style={{ ...uiStyles.input, maxWidth: "240px" }}
              required
            />
            <button type="submit" style={uiStyles.btnPrimary}>Save</button>
          </form>

          <div className="table-responsive">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>{isStatus ? "Count" : "Status"}</th>
                  <th style={{ textAlign: "right" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {listData.map((item, i) => (
                  <tr key={item.id}>
                    <td>{i + 1}</td>
                    <td style={{ fontWeight: 600 }}>{item.name}</td>
                    <td>{isStatus ? item.count : item.status}</td>
                    <td style={{ textAlign: "right" }}>
                      <button
                        onClick={() => {
                          if (isStatus) {
                            setFormSC({ name: item.name, count: item.count });
                            setEditingSC(item.id);
                          } else {
                            setFormWc({ name: item.name, status: item.status });
                            setEditingWc(item.id);
                          }
                        }}
                        style={uiStyles.btnIcon}
                      >
                        <FaEdit />
                      </button>
                      <button
                        onClick={async () => {
                          if (window.confirm("Delete item?")) {
                            if (isStatus) {
                              await axios.delete(`${API}/api/status-cards/${item.id}`);
                              fetchStatusCards();
                            } else {
                              await axios.delete(`${API}/api/why-choose-cards/${item.id}`);
                              fetchCards();
                            }
                          }
                        }}
                        style={uiStyles.btnIconDanger}
                      >
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      );
    }

    return null;
  };

  return (
    <>
      <style>{globalStyles}</style>
      <div style={{ display: "flex", minHeight: "100vh", backgroundColor: theme.bgApp }}>
        {/* Mobile Backdrop */}
        <div
          className={`mobile-overlay ${sidebarOpen && isMobile ? "show" : ""}`}
          onClick={() => setSidebarOpen(false)}
        />

        {/* Sidebar */}
        <aside
          className={`sidebar-drawer ${sidebarOpen ? "open" : ""}`}
          style={{
            width: sidebarOpen ? "250px" : isMobile ? "250px" : "70px",
            backgroundColor: theme.primary,
            color: "#fff",
            position: "fixed",
            top: 0,
            bottom: 0,
            left: 0,
            zIndex: 50,
            display: "flex",
            flexDirection: "column",
            transition: "width 0.2s ease",
            boxShadow: theme.shadowMd,
          }}
        >
          {/* Logo Area */}
          <div style={{ height: "64px", display: "flex", alignItems: "center", padding: "0 20px", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
            <span style={{ fontWeight: 700, fontSize: "1.2rem", letterSpacing: "1px", color: "#fff" }}>
              {sidebarOpen || isMobile ? "INFOSIGHT" : "IS"}
            </span>
          </div>

          {/* Navigation Links */}
          <nav style={{ flex: 1, overflowY: "auto", padding: "12px 8px" }}>
            {navItems.map((item) => {
              const active = activeComponent === item.label;
              return (
                <div
                  key={item.label}
                  onClick={() => {
                    setActiveComponent(item.label);
                    if (isMobile) setSidebarOpen(false);
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "10px 12px",
                    borderRadius: "8px",
                    cursor: "pointer",
                    marginBottom: "4px",
                    backgroundColor: active ? "rgba(255,255,255,0.12)" : "transparent",
                    color: active ? "#FFF" : "#A0AEC0",
                    transition: "all 0.2s ease",
                  }}
                >
                  <div style={{ fontSize: "1.2rem", display: "flex", alignItems: "center" }}>{item.icon}</div>
                  {(sidebarOpen || isMobile) && (
                    <span style={{ marginLeft: "12px", fontSize: "0.9rem", fontWeight: active ? 600 : 400 }}>
                      {item.label}
                    </span>
                  )}
                </div>
              );
            })}
          </nav>
        </aside>

        {/* Main Content Layout */}
        <div
          style={{
            flex: 1,
            marginLeft: isMobile ? 0 : sidebarOpen ? "250px" : "70px",
            transition: "margin-left 0.2s ease",
            display: "flex",
            flexDirection: "column",
            minWidth: 0,
          }}
        >
          {/* Top Header */}
          <header
            style={{
              height: "64px",
              backgroundColor: theme.bgSurface,
              borderBottom: `1px solid ${theme.border}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "0 20px",
              position: "sticky",
              top: 0,
              zIndex: 30,
            }}
          >
            <button onClick={() => setSidebarOpen(!sidebarOpen)} style={{ background: "none", border: "none", cursor: "pointer", color: theme.textPrimary, fontSize: "1.2rem" }}>
              <FaBars />
            </button>

            {/* Profile Dropdown */}
            <div style={{ position: "relative" }} ref={profileMenuRef}>
              <div onClick={() => setShowProfileMenu(!showProfileMenu)} style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}>
                <FaUserCircle size={28} color={theme.primary} />
                <span style={{ fontSize: "0.9rem", fontWeight: 500, color: theme.textPrimary, display: isMobile ? "none" : "inline" }}>
                  {adminEmail}
                </span>
              </div>

              {showProfileMenu && (
                <div
                  style={{
                    position: "absolute",
                    right: 0,
                    top: "120%",
                    backgroundColor: theme.bgSurface,
                    borderRadius: "8px",
                    boxShadow: theme.shadowLg,
                    border: `1px solid ${theme.border}`,
                    width: "160px",
                    overflow: "hidden",
                    zIndex: 100,
                  }}
                >
                  <div
                    onClick={handleLogout}
                    style={{
                      padding: "10px 16px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      color: theme.danger,
                      fontSize: "0.9rem",
                      fontWeight: 500,
                      cursor: "pointer",
                    }}
                  >
                    <FaSignOutAlt /> Logout
                  </div>
                </div>
              )}
            </div>
          </header>

          {/* Main Dashboard Workspace */}
          <main style={{ flex: 1, padding: "20px" }}>{renderContent()}</main>
        </div>
      </div>
    </>
  );
};

// Clean Modular UI Styles
const uiStyles = {
  card: {
    backgroundColor: theme.bgSurface,
    borderRadius: theme.radius,
    padding: "24px",
    border: `1px solid ${theme.border}`,
    boxShadow: theme.shadowSm,
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
    flexWrap: "wrap",
    gap: "12px",
  },
  heading: {
    fontSize: "1.25rem",
    fontWeight: "700",
    color: theme.textPrimary,
  },
  label: {
    display: "block",
    fontSize: "0.825rem",
    fontWeight: "600",
    color: theme.textPrimary,
    marginBottom: "4px",
  },
  input: {
    width: "100%",
    padding: "8px 12px",
    borderRadius: "6px",
    border: `1px solid ${theme.border}`,
    fontSize: "0.9rem",
    outline: "none",
    backgroundColor: "#F8FAFC",
    color: theme.textPrimary,
  },
  btnPrimary: {
    backgroundColor: theme.primary,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    padding: "8px 16px",
    fontSize: "0.9rem",
    fontWeight: "500",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
  },
  btnSecondary: {
    backgroundColor: theme.bgSubtle,
    color: theme.textPrimary,
    border: `1px solid ${theme.border}`,
    borderRadius: "6px",
    padding: "6px 12px",
    fontSize: "0.85rem",
    cursor: "pointer",
  },
  btnIcon: {
    backgroundColor: theme.bgSubtle,
    color: theme.primary,
    border: "none",
    borderRadius: "4px",
    padding: "6px 10px",
    cursor: "pointer",
    marginRight: "6px",
  },
  btnIconDanger: {
    backgroundColor: theme.dangerLight,
    color: theme.danger,
    border: "none",
    borderRadius: "4px",
    padding: "6px 10px",
    cursor: "pointer",
  },
  statCard: {
    backgroundColor: theme.bgSubtle,
    padding: "16px",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  statLabel: {
    fontSize: "0.8rem",
    color: theme.textSecondary,
    fontWeight: 500,
  },
  statValue: {
    fontSize: "1.5rem",
    fontWeight: "700",
    color: theme.textPrimary,
  },
  modalOverlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(15, 23, 42, 0.4)",
    backdropFilter: "blur(2px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
    padding: "16px",
  },
  modalContent: {
    backgroundColor: theme.bgSurface,
    borderRadius: theme.radius,
    width: "100%",
    maxWidth: "480px",
    maxHeight: "90vh",
    overflowY: "auto",
    padding: "24px",
    boxShadow: theme.shadowLg,
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
  },
};

export default AdminDashboard;